<template>
  <div :key="page_key" class="page__flash_sale a-page">
    <div style="background-color:white; padding: 15px; border-radius: 4px; overflow: hidden">
      <el-row>
        <el-col :sm="12">
          <el-select v-if="false" size="small" :placeholder="$t('select.shop')" v-model="shopee_shop.selected"
                     filterable>
            <el-option-group :label="$t('shop.added')">
              <el-option v-for="item in shopee_shop.list.filter(i => !i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
            <el-option-group :label="$t('shop.managed')">
              <el-option v-for="item in shopee_shop.list.filter(i => i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
          </el-select>
          <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"></shop-select>
        </el-col>
      </el-row>

      <br>
      <br>
      <br>

      <el-tabs v-model="tab">
        <el-tab-pane :label="$t('base.product')" name="product">
          <div v-if="!shop._id"
               style="margin-top: 30px; width: 100%; height: 60px; line-height: 56px; border: 2px solid #ccccd6; border-radius: 50px; text-align: center; font-size: 15px; font-weight: 700;">
            {{ $t('center.select_shop_to_use_feature') }}.
          </div>
          <div v-else-if="shop.extra_data && !shop.extra_data.linked"
               style="margin-top: 30px; width: 100%; height: 60px; line-height: 56px; border: 2px solid #ccccd6; border-radius: 50px; text-align: center; font-size: 15px; font-weight: 700;">
            {{ $t('center.shop_need_to_link') }}.
            <a href="javascript:void(0)" style="font-size: 15px; text-decoration: underline !important;"
               @click="m__get_login">
              {{ $t('center.link_account') }}.</a>
          </div>
          <div v-else style="margin-top: 30px">
            <el-row>
              <el-col :sm="8">
                <strong v-if="!loading.get_product" style="font-size: 15px">
                  {{ $t('base.products') }}
                  <a v-if="shopee_shop.selected" href="javascript:void(0)" class="text-primary" style="font-size: 15px"
                     @click="m__initial_view">
                    ({{ $t('base.reload_data') }})
                  </a>
                </strong>
                <strong v-else class="text-danger" style="font-size: 15px">
                  <i class="el-icon-loading"></i> {{ $t('base.loading_products') }}
                </strong>
              </el-col>
              <el-col :sm="16" class="text-right">
                <strong style="font-size: 13px" class="text-danger">
                  *{{ $t('product.change_name_note') }}
                </strong>
              </el-col>
            </el-row>
            <br>
            <br>
            <el-row>
              <el-col :sm="2">
                <el-select size="mini" value="" v-model="filter.page_size">
                  <el-option v-for="item in filter.pages" :key="item" :value="item" :label="item"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="4" style="padding-left: 10px">
                <el-select size="mini" value="" v-model="period" class="full-w">
                  <el-option value="past7days" :label="$t('metric.past7days')"></el-option>
                  <el-option value="past30days" :label="$t('metric.past30days')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="4" style="padding-left: 10px">
                <el-input size="mini" v-model="filter.keyword" :placeholder="$t('input.placeholder')"
                          suffix-icon="el-icon-search" clearable></el-input>
              </el-col>
            </el-row>
            <br>
            <br>
            <el-row>
              <el-col :sm="4">
                <el-select size="mini" value="" v-model="filter.group_id">
                  <el-option :value="''" :label="$t('base.all_products')"></el-option>
                  <el-option v-for="item in group_list" :key="item.id" :value="item.id"
                             :label="`${$t('base.group')}: ${item.name}`"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="20" class="text-right">
                <el-dropdown trigger="click" @command="m__handle_dropdown">
                  <el-button size="mini">
                    {{ $t('base.mass_setup') }}
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="1">
                      {{ $t('product.add_to_group') }}
                    </el-dropdown-item>
                    <el-dropdown-item :command="2">
                      {{ $t('product.remove_from_group') }}
                    </el-dropdown-item>
                    <el-dropdown-item :command="3" divided>
                      {{ $t('product.add_restricted_keywords_file') }}
                    </el-dropdown-item>
                    <el-dropdown-item :command="4">
                      {{ $t('product.delete_restricted_keywords') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                &nbsp;
                &nbsp;
                <el-dropdown trigger="click" @command="m__handle_dropdown">
                  <el-button size="mini" type="primary" icon="el-icon-edit">
                    {{ $t('product.mass_edit_name') }}
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="5">
                      <i class="el-icon-plus"></i> {{ $t('product.add_text') }}
                    </el-dropdown-item>
                    <el-dropdown-item :command="7">
                      <i class="el-icon-edit-outline"></i> {{ $t('product.replace_text') }}
                    </el-dropdown-item>
                    <el-dropdown-item :command="6">
                      <i class="el-icon-close"></i> {{ $t('product.remove_text') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                &nbsp;
                &nbsp;
                <el-button size="mini" type="primary" icon="el-icon-picture-outline"
                           @click="m__show_attach_frame_dialog(null)">
                  {{ $t('product.mass_add_frame') }}
                </el-button>
                <el-button size="mini" type="default" icon="el-icon-close" :loading="loading.delete_frame_multiple"
                           @click="m__show_delete_frame_multiple_dialog(null)">
                  {{ $t('product.mass_remove_frame') }}
                </el-button>
              </el-col>
            </el-row>

            <br>
            <br>

            <el-table id="main-table-fixed-header" :data="[]" style="display: none;">
              <el-table-column label="#" width="40px" fixed="left">
                <template slot="header" slot-scope="scope">
                  <el-checkbox size="mini" v-bind:value="m__is_checked_all()" @change="m__check_all"
                               :disabled="loading.get_product"></el-checkbox>
                </template>
                <template slot-scope="scope">
                  <el-checkbox size="mini" v-model="scope.row.checked"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.product')" width="80px" fixed="left">
                <template slot-scope="scope">
                  <img :src="SHOPEE_IMAGE(scope.row.images[0])" alt="logo"
                       style="width:56px; height: 56px;">
                </template>
              </el-table-column>
              <el-table-column width="300px" show-tooltip-when-overflow fixed="left">
                <template slot-scope="scope">
                  <div class="text-overflow">
                    <a href="javascript:void(0)"
                       @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                      {{ scope.row.name }}
                    </a>
                  </div>
                  <div>
                    {{ $t('product.id') }}: {{ scope.row.id }}
                  </div>
                  <div>
                    <span v-if="scope.row.group_id" class="text-running" style="margin-right: 5px">
                      <a href="javascript:void(0)">{{ scope.row.group_name }}</a>
                    </span>
                    <span v-if="scope.row.restricted_keyword_id" class="text-running" style="margin-right: 5px">
                      <a href="javascript:void(0)">{{ scope.row.restricted_keyword_name }}</a>
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.created_at')" width="120px" prop="create_time" sortable="custom">
                <template slot-scope="scope">
                  {{ scope.row.create_time * 1000 | moment('DD/MM/YYYY') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.price')" prop="price" sortable="custom" width="150px">
                <template slot-scope="scope">
                  <span>{{ +scope.row.price ? +scope.row.price : scope.row.price_before_discount | currency }}đ</span>
                  <br>
                  <span v-if="+scope.row.price" style="text-decoration: line-through; color: #999">{{
                      scope.row.price_before_discount | currency
                    }}đ</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.stock')" prop="models_stock" sortable="custom" width="150px">
              </el-table-column>
              <el-table-column :label="$t('metric.impressions')" prop="performance.pv" sortable="custom" width="150px">
                <template slot-scope="scope">
                  {{ scope.row.performance.pv | currency }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('metric.add_to_cart_units')" prop="performance.add_to_cart_units"
                               sortable="custom" width="150px">
                <template slot-scope="scope">
                  {{ scope.row.performance.add_to_cart_units | currency }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('center.add_to_cart_rate_on_view')" prop="performance.pv_to_add_to_cart_rate"
                               sortable="custom"
                               width="160px">
                <template slot-scope="scope">
                  {{ scope.row.performance.pv_to_add_to_cart_rate }}%
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.sold')" prop="performance.confirmed_units" sortable="custom"
                               width="150px">
                <template slot-scope="scope">
                  {{ scope.row.performance.confirmed_units | currency }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('center.placed_units_on_add_to_cart_units_rate')"
                               prop="performance.add_to_cart_to_confirmed_units_rate"
                               sortable="custom" width="180px">
                <template slot-scope="scope">
                  {{ scope.row.performance.add_to_cart_to_confirmed_units_rate }}%
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.sales')" prop="performance.confirmed_sales" sortable="custom"
                               width="150px">
                <template slot-scope="scope">
                  {{ m__calculate(scope.row.performance.confirmed_sales) | currency }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.optional')" width="120px" fixed="right">
                <template slot-scope="scope">
                  <el-dropdown trigger="click">
                    <el-button size="mini" type="text">
                      <strong class="text-warning"><i class="el-icon-edit text-warning"></i>
                        {{ $t('base.update') }}</strong>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.nat.native="m__show_dialog_change_name(scope.row)">
                        {{ $t('product.edit_name') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="m__show_upload_image_dialog(scope.row)">
                        {{ $t('product.edit_cover_image') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="m__show_attach_frame_dialog(scope.row)">
                        {{ $t('product.add_frame') }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <br>
                  <el-button size="mini" type="text" :loading="loading.change_product_name_log"
                             @click="m__get_change_product_name_log(scope.row)">
                    <strong class="text-info">{{ $t('product.history_edit_name') }}</strong>
                  </el-button>
                  <br>
                  <el-button size="mini" type="text" :loading="loading.change_product_images_log"
                             @click="m__get_change_product_images_log(scope.row)">
                    <strong class="text-info">{{ $t('product.history_edit_image') }}</strong>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-table id="main-table" :data="list_display" @sort-change="m__sort_change">
              <el-table-column label="#" width="40px" fixed="left">
                <template slot="header" slot-scope="scope">
                  <el-checkbox size="mini" v-bind:value="m__is_checked_all()" @change="m__check_all"
                               :disabled="loading.get_product"></el-checkbox>
                </template>
                <template slot-scope="scope">
                  <el-checkbox size="mini" v-model="scope.row.checked"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.product')" width="80px" fixed="left">
                <template slot-scope="scope">
                  <img :src="SHOPEE_IMAGE(scope.row.images[0])" alt="logo"
                       style="width:56px; height: 56px;">
                </template>
              </el-table-column>
              <el-table-column width="300px" show-tooltip-when-overflow fixed="left">
                <template slot-scope="scope">
                  <div class="text-overflow">
                    <a href="javascript:void(0)"
                       @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                      {{ scope.row.name }}
                    </a>
                  </div>
                  <div>
                    {{ $t('product.id') }}: {{ scope.row.id }}
                  </div>
                  <div>
                    SKU: {{ scope.row.parent_sku || '-' }}
                  </div>
                  <div>
                    <span v-if="scope.row.group_id" class="text-running" style="margin-right: 5px">
                      <a href="javascript:void(0)">{{ scope.row.group_name }}</a>
                    </span>
                    <span v-if="scope.row.restricted_keyword_id" class="text-running" style="margin-right: 5px">
                      <a href="javascript:void(0)">{{ scope.row.restricted_keyword_name }}</a>
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.created_at')" width="120px" prop="create_time" sortable="custom">
                <template slot-scope="scope">
                  {{ scope.row.create_time * 1000 | moment('DD/MM/YYYY') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.price')" prop="price" sortable="custom" width="150px">
                <template slot-scope="scope">
                  <span>{{ +scope.row.price ? +scope.row.price : scope.row.price_before_discount | currency }}đ</span>
                  <br>
                  <span v-if="+scope.row.price" style="text-decoration: line-through; color: #999">{{
                      scope.row.price_before_discount | currency
                    }}đ</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.stock')" prop="models_stock" sortable="custom" width="150px">
              </el-table-column>
              <!--              <el-table-column :label="$t('base.sold')" prop="sold" sortable="custom">
                              <template slot-scope="scope">
                                {{ scope.row.sold }}
                              </template>
                            </el-table-column>
                            <el-table-column :label="$t('base.sales')" prop="gmv" sortable="custom">
                              <template slot-scope="scope">
                                {{ scope.row.gmv | currency }}
                              </template>
                            </el-table-column>
                            <el-table-column :label="$t('metric.impressions')" prop="view_count" sortable="custom">
                            </el-table-column>-->
              <el-table-column :label="$t('metric.impressions')" prop="performance.pv" sortable="custom" width="150px">
                <template slot-scope="scope">
                  {{ scope.row.performance.pv | currency }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('metric.add_to_cart_units')" prop="performance.add_to_cart_units"
                               sortable="custom" width="150px">
                <template slot-scope="scope">
                  {{ scope.row.performance.add_to_cart_units | currency }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('center.add_to_cart_rate_on_view')" prop="performance.pv_to_add_to_cart_rate"
                               sortable="custom"
                               width="160px">
                <template slot-scope="scope">
                  {{ scope.row.performance.pv_to_add_to_cart_rate }}%
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.sold')" prop="performance.confirmed_units" sortable="custom"
                               width="150px">
                <template slot-scope="scope">
                  {{ scope.row.performance.confirmed_units | currency }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('center.placed_units_on_add_to_cart_units_rate')"
                               prop="performance.add_to_cart_to_confirmed_units_rate"
                               sortable="custom" width="180px">
                <template slot-scope="scope">
                  {{ scope.row.performance.add_to_cart_to_confirmed_units_rate }}%
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.sales')" prop="performance.confirmed_sales" sortable="custom"
                               width="150px">
                <template slot-scope="scope">
                  {{ m__calculate(scope.row.performance.confirmed_sales) | currency }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.optional')" width="120px" fixed="right">
                <template slot-scope="scope">
                  <el-dropdown trigger="click">
                    <el-button size="mini" type="text">
                      <strong class="text-warning"><i class="el-icon-edit text-warning"></i> {{
                          $t('base.update')
                        }}</strong>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.nat.native="m__show_dialog_change_name(scope.row)">
                        {{ $t('product.edit_name') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="m__show_upload_image_dialog(scope.row)">
                        {{ $t('product.edit_cover_image') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="m__show_attach_frame_dialog(scope.row)">
                        {{ $t('product.add_frame') }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <br>
                  <el-button size="mini" type="text" :loading="loading.change_product_name_log"
                             @click="m__get_change_product_name_log(scope.row)">
                    <strong class="text-info">{{ $t('product.history_edit_name') }}</strong>
                  </el-button>
                  <br>
                  <el-button size="mini" type="text" :loading="loading.change_product_images_log"
                             @click="m__get_change_product_images_log(scope.row)">
                    <strong class="text-info">{{ $t('product.history_edit_image') }}</strong>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page.sync="filter.current_page"
              :page-size="filter.page_size"
              layout="total, prev, pager, next"
              :total="list_true.length">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('product.group')" name="group">
          <div style="margin-top: 30px">
            <el-row>
              <el-col :sm="8">
                <strong v-if="!loading.get_product" style="font-size: 15px">
                  {{ $t('product.group_list') }}
                </strong>
                <strong v-else class="text-danger" style="font-size: 15px">
                  <i class="el-icon-loading"></i> {{ $t('base.loading_products') }}
                </strong>
              </el-col>
              <el-col :sm="16" class="text-right">
              </el-col>
            </el-row>
            <br>
            <br>
            <el-row>
              <el-col :sm="6" style="padding-right: 20px">
                &nbsp;
              </el-col>
              <el-col :sm="18" class="text-right">
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="m__show_add_group_dialog">
                  {{ $t('product.add_group') }}
                </el-button>
              </el-col>
            </el-row>
            <br>
            <br>
            <el-table :data="group_list">
              <el-table-column :label="$t('product.group_name')" prop="name">
                <template slot-scope="scope">{{ scope.row.name }}</template>
              </el-table-column>
              <el-table-column :label="$t('base.info')">
                <template slot-scope="scope">
                  {{ scope.row.productIds.length }} {{ $t('base.products') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.created_at')">
                <template slot-scope="scope">
                  {{ scope.row.createdAt | moment('DD/MM/YYYY') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.optional')">
                <template slot-scope="scope">
                  <el-button size="mini" type="success" icon="el-icon-plus" @click="tab = 'product'">
                    {{ $t('base.add_products') }}
                  </el-button>
                  &nbsp;&nbsp;
                  <el-button size="mini" type="danger" icon="el-icon-delete"
                             @click="m__delete_product_group(scope.row)">
                    {{ $t('base.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="restricted_keyword_fixed_list.some(i => $store.state.userInfo.username.includes(i))"
                     :label="$t('product.restricted_keywords')" name="keyword">
          <div style="margin-top: 30px">
            <el-row>
              <el-col :sm="8">
                <strong v-if="!loading.get_product" style="font-size: 15px">
                  {{ $t('product.restricted_keywords_file') }}
                </strong>
                <strong v-else class="text-danger" style="font-size: 15px">
                  <i class="el-icon-loading"></i> {{ $t('base.loading_products') }}
                </strong>
              </el-col>
              <el-col :sm="16" class="text-right">
              </el-col>
            </el-row>
            <br>
            <br>
            <el-row>
              <el-col :sm="6" style="padding-right: 20px">
                &nbsp;
              </el-col>
              <el-col :sm="18" class="text-right">
                <el-button type="primary" size="mini" icon="el-icon-plus"
                           @click="m__show_add_restricted_keyword_dialog">
                  {{ $t('product.add_restricted_keywords_file') }}
                </el-button>
              </el-col>
            </el-row>
            <br>
            <br>
            <el-table :data="restricted_keywords">
              <el-table-column :label="$t('base.filename')" prop="name">
                <template slot-scope="scope">{{ scope.row.name }}</template>
              </el-table-column>
              <el-table-column :label="$t('base.info')">
                <template slot-scope="scope">
                  {{ scope.row.productIds.length }} {{ $t('base.products') }}
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  {{ scope.row.keywords.length }} {{ $t('base.keywords') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.created_at')">
                <template slot-scope="scope">
                  {{ scope.row.createdAt | moment('DD/MM/YYYY') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.optional')">
                <template slot-scope="scope">
                  <el-button size="mini" type="warning" icon="el-icon-edit"
                             @click="m__show_update_keyword_dialog(scope.row)">
                    {{ $t('base.edit') }}
                  </el-button>
                  &nbsp;&nbsp;
                  <el-button size="mini" type="danger" icon="el-icon-delete"
                             @click="m__delete_restricted_keyword(scope.row)">
                    {{ $t('base.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog :visible.sync="show_dialog.review_product" :close-on-click-modal="false" width="1200px">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 14px">{{ $t('product.preview_products') }}</strong>

        <el-table :data="review_list_display">
          <el-table-column width="80px">
            <template slot-scope="scope">
              <img :src="SHOPEE_IMAGE(scope.row.images[0])" alt="logo"
                   style="width:56px; height: 56px;">
            </template>
          </el-table-column>
          <el-table-column prop="old_name" :label="$t('base.old_name')"></el-table-column>
          <el-table-column prop="new_name" :label="$t('base.new_name')"></el-table-column>
          <el-table-column :label="$t('base.length')" width="120px">
            <template slot-scope="scope">
              <strong :class="scope.row.new_name.length <= 120 ? 'text-success' : 'text-danger'">
                {{ scope.row.new_name.length }}
              </strong>
              <strong>/120</strong>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.result')" width="200px">
            <template slot-scope="scope">
              <strong :class="scope.row.update_status ? 'text-success' : 'text-danger'">
                {{ scope.row.update_message }}
              </strong>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 20px">
          <el-col :sm="12">
            <el-pagination
              :current-page.sync="review_filter.current_page"
              :page-size="review_filter.page_size"
              layout="total, prev, pager, next"
              :total="review_list.length">
            </el-pagination>
          </el-col>
          <el-col :sm="12" class="text-right  ">
            <el-button size="mini" type="primary" icon="el-icon-check" @click="m__update_on_review"
                       :loading="loading.update_on_review">
              {{ $t('base.update') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_text_multiple" :close-on-click-modal="false" width="500px">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 14px">{{ $t('product.mass_add_text') }}</strong>

        <br>
        <br>

        <p class="text-title">Text:</p>
        <el-input size="mini" v-model="form_add_text_multiple.text"
                  :placeholder="$t('input.text')"></el-input>

        <br>
        <br>
        <p class="text-title">{{ $t('product.text_insert_position') }}</p>
        <div style="display: flex; flex-wrap: wrap; align-items: start; gap: 40px; margin-top: 10px">
          <div>
            <el-radio v-model="form_add_text_multiple.position" label="start">{{ $t('product.before_name') }}</el-radio>
          </div>
          <div>
            <el-radio v-model="form_add_text_multiple.position" label="end">{{ $t('product.after_name') }}</el-radio>
          </div>
        </div>
        <div v-if="array_to_set(after_n_char_fixed_list).has($store.state.userInfo.username)"
             style="margin-top: 25px; width: 45%">
          <div>
            <el-radio v-model="form_add_text_multiple.position" label="after_n_char">
              {{ $t('product.after_x_character', {x: form_add_text_multiple.n_char || 0}) }}
            </el-radio>
          </div>
          <div style="margin-top: 5px">
            <el-input v-model="form_add_text_multiple.n_char" size="mini" type="number"
                      :disabled="form_add_text_multiple.position !== 'after_n_char'"></el-input>
          </div>
        </div>

        <el-row style="margin-top: 50px">
          <el-col :span="12" style="padding-top: 5px; display: flex; align-items: center; gap: 5px">
            <input type="checkbox" v-model="ignore_review" style="margin: 0"></input>
            <span>
                {{ $t('product.skip_products_preview') }}
              </span>
          </el-col>
          <el-col :span="12" class="text-right">
            <el-button type="primary" icon="el-icon-check" size="mini" @click="m__review_add_text_multiple_dialog"
                       :loading="loading.add_text_multiple">
              {{ ignore_review ? $t('base.confirm') : $t('base.preview') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.remove_text_multiple" :close-on-click-modal="false" width="500px">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 14px">{{ $t('product.mass_remove_text') }}</strong>

        <p class="text-title">Text:</p>
        <el-input size="mini" v-model="form_remove_text_multiple.text"
                  :placeholder="$t('product.input_remove_text')"></el-input>

        <p class="text-title">{{ $t('base.other_options') }}</p>
        <el-row style="padding-top: 3px">
          <el-col :span="12">
            <el-checkbox size="mini" v-model="form_remove_text_multiple.upper_case"></el-checkbox>
            &nbsp;&nbsp;<strong style="color: orangered">{{ $t('product.uppercase_letter') }}</strong>
          </el-col>
          <el-col :span="12">
            <el-checkbox size="mini" v-model="form_remove_text_multiple.once"></el-checkbox>
            &nbsp;&nbsp;<strong style="color: orangered">{{ $t('product.remove_only_once') }}</strong>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <el-col :span="12" style="padding-top: 5px; display: flex; align-items: center; gap: 5px">
            <input type="checkbox" v-model="ignore_review" style="margin: 0"></input>
            <span>
              {{ $t('product.skip_products_preview') }}
            </span>
          </el-col>
          <el-col :span="12" class="text-right">
            <el-button type="primary" icon="el-icon-check" size="mini" @click="m__review_remove_text_multiple_dialog"
                       :loading="loading.remove_text_multiple">
              {{ ignore_review ? $t('base.confirm') : $t('base.preview') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_group" :close-on-click-modal="false" width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('product.add_group') }}</strong>

        <div style="margin-top: 20px;">
          <strong class="strong-label">{{ $t('product.group_name') }}</strong>
          <el-input v-model="form_group.name" size="mini" :placeholder="$t('input.product_group_name')"></el-input>
        </div>

        <div style="margin-top: 20px;" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.add_group" @click="m__add_group">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_product_to_group" :close-on-click-modal="false" width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('product.add_to_group') }}</strong>

        <div style="margin-top: 20px;">
          <strong class="strong-label">{{ $t('select.group') }}</strong>
          <el-select size="mini" class="full-w" v-model="form_group.groupId" :placeholder="$t('select.group')"
                     filterable>
            <el-option v-for="item in group_list" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px;" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.add_product_to_group"
                     @click="m__add_product_to_group">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_product_to_restricted_keyword" :close-on-click-modal="false"
               width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('product.add_restricted_keywords') }}</strong>

        <div style="margin-top: 20px;">
          <strong class="strong-label">{{ $t('select.file') }}</strong>
          <el-select size="mini" class="full-w" v-model="selected_restricted_keyword_id"
                     :placeholder="$t('select.file')" filterable>
            <el-option v-for="item in restricted_keywords" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px;" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check"
                     :loading="loading.add_product_to_restricted_keyword" @click="m__add_restricted_keyword_product">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_restricted_keyword" :close-on-click-modal="false" width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('product.add_restricted_keywords_file') }}</strong>

        <div style="margin-top: 20px;">
          <strong class="strong-label">{{ $t('base.filename') }}</strong>
          <el-input v-model="form_restricted_keyword.name" size="mini" :placeholder="$t('input.filename')"></el-input>
        </div>

        <div style="margin-top: 20px;" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.add_restricted_keyword"
                     @click="m__add_restricted_keyword">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_keyword" :close-on-click-modal="false" width="600px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">
          {{ $t('product.update_restricted_keywords_file') }}
          {{ form_restricted_keyword.name }}
        </strong>

        <div style="margin-top: 30px;">
          <el-row>
            <el-col :sm="20">
              <el-input v-model="restricted_keyword" size="mini" style="width: 55%"
                        :placeholder="$t('input.keyword')" @keyup.enter.native="m__add_keyword"></el-input>
              &nbsp;
              <el-button type="primary" size="mini" style="width: 18%" @click="m__add_keyword">
                {{ $t('base.add') }}
              </el-button>
              <el-button type="info" size="mini" style="width: 18%" @click="m__select_file">Import</el-button>
            </el-col>
            <el-col :sm="4" class="text-right">
              <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.update_restricted_keyword"
                         @click="m__update_restricted_keyword">
                {{ $t('base.save_file') }}
              </el-button>
            </el-col>
          </el-row>
        </div>

        <div style="margin-top: 30px;">
          <el-table :data="form_restricted_keyword.keywords">
            <el-table-column :label="$t('base.keyword')" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row }}
              </template>
            </el-table-column>
            <el-table-column label="Unicode" width="100px">
              <template slot-scope="scope">
                {{ scope.row === scope.row.normalize() ? $t('base.precomposed') : $t('base.combining') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.optional')" width="100px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__remove_keyword(scope.$index)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.upload_image" :close-on-click-modal="false" width="700px">
      <div slot="title" style="padding:10px">
        <div>
          <p class="strong-title">
            {{ $t('product.edit_product_cover_image') }}:
            <strong class="text-primary" style="font-size: 14px">{{ selected_product.name }}</strong>
          </p>
        </div>

        <div style="margin-top: 30px">
          <strong class="strong-label text-danger">
            {{ $t('product.edit_product_cover_image_note') }}
          </strong>
        </div>

        <div style="margin-top: 60px; display: flex; justify-content: center">
          <el-upload v-if="!preview_image" class="upload-demo" drag action="#"
                     :auto-upload="false"
                     :on-change="m__on_preview_upload_image">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">{{ $t('product.drag_and_drop_image') }} <em>{{
                $t('product.click_to_upload')
              }}</em></div>
            <div class="el-upload__tip" slot="tip">{{ $t('product.required_image_format') }}</div>
          </el-upload>
          <div v-else>
            <div style="width: 650px; height: 20px; border-radius: 5px; display: flex; gap: 50px">
              <div style="flex: 1; display: flex; flex-direction: column; gap: 10px; height: 100%">
                <strong class="strong-label">{{ $t('product.old_image') }}</strong>
              </div>
              <div style="flex: 1; display: flex; flex-direction: column; gap: 10px; height: 100%">
                <strong class="strong-label">{{ $t('product.new_image') }}</strong>
              </div>
            </div>
            <div style="width: 650px; height: 300px; border-radius: 5px; display: flex; gap: 50px">
              <div style="flex: 1; display: flex; flex-direction: column; gap: 10px; height: 100%">
                <img :src="SHOPEE_IMAGE(selected_product.images ? selected_product.images[0] : '')" alt=""
                     style="width: 100%; height: 100%; object-fit: cover"/>
              </div>
              <div style="flex: 1; display: flex; flex-direction: column; gap: 10px; height: 100%">
                <img :src="preview_image_url" alt="" style="width: 100%; height: 100%; object-fit: cover"/>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 60px; text-align: center">
          <el-button v-if="preview_image" type="info" size="mini" icon="el-icon-refresh"
                     @click="preview_image = null; preview_image_url = null">
            {{ $t('product.use_other_image') }}
          </el-button>
          <el-button v-if="preview_image" type="primary" size="mini" icon="el-icon-check"
                     :loading="loading.upload_image"
                     @click="m__confirm_upload_image">
            {{ $t('product.confirm_edit_cover') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.attach_frame" :close-on-click-modal="false"
               :width="add_frame_display === 'all' ? '1200px' : '800px'">
      <div slot="title" style="padding:10px">
        <div>
          <p class="strong-title">
            {{ $t('product.add_frame_product_image') }}
          </p>
        </div>

        <div style="margin-top: 30px">
          <strong class="strong-label text-danger">
            {{ $t('base.attention') }}:
          </strong>
          <strong class="strong-label text-danger">
            - {{ $t('product.attention_1') }}
          </strong>
          <strong class="strong-label text-danger">
            - {{ $t('product.attention_2') }}
          </strong>
          <strong class="strong-label text-danger">
            - {{ $t('product.attention_3') }}
            <a href="https://drive.google.com/drive/u/7/folders/1rGmELdRgH3XUyuYLM4KLw2WdO3g-FXnv" target="_blank"
               style="font-size: 14px">{{ $t('base.here') }}.</a>
          </strong>
        </div>

        <div v-if="!selected_frame" style="margin-top: 60px">
          <div style="margin: 30px 0; display: flex; gap: 30px">
            <div style="flex: 0 1 auto; display: flex; gap: 30px">
              <el-radio size="medium" v-model="attach_frame_type" label="main">
                {{ $t('product.edit_cover_image_only') }}
              </el-radio>
              <el-radio v-if="add_frame_display === 'all'" size="medium" v-model="attach_frame_type" label="all">
                {{ $t('product.apply_for_multiple_images') }}
              </el-radio>
              <el-radio v-else size="medium" v-model="attach_frame_type" label="multiple">
                {{ $t('product.apply_for_multiple_images') }}
              </el-radio>
            </div>
            <div style="flex: 1; text-align: right; margin-right: 60px">
              <el-radio-group size="mini" v-model="frame_display_type">
                <el-radio-button label="all">{{ $t('product.all_frames') }}</el-radio-button>
                <el-radio-button label="sale">{{ $t('product.frames_for_spike_day') }}</el-radio-button>
              </el-radio-group>
            </div>
          </div>

          <el-upload
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            :file-list="frame_list_display"
            :on-change="m__upload_frame"
            class="upload-demo">
            <div slot="file" slot-scope="{file}">
              <div v-if="file.more"
                   style="background-color: #fbfdff; border: 1px dashed #c0ccda; border-radius: 6px; box-sizing: border-box; line-height: 146px; vertical-align: top; text-align: center;"
                   @click="show_full_frame = true">
                {{ $t('product.check_other_frames') }}
              </div>
              <div v-else @click="m__select_frame(file)">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url" alt=""
                />
              </div>
            </div>
            <span v-if="frame_display_type === 'all'" slot="default">{{ $t('product.upload_frames') }}</span>
          </el-upload>
        </div>
        <div v-else style="margin-top: 60px">
          <template v-if="add_frame_display === 'all'">
            <el-table :data="attach_result_list">
              <el-table-column>
                <template slot-scope="scope">
                  <div style="margin-top: 10px">
                    <div style="width: 50%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                      <a href="javascript:void(0)"
                         @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                        {{ scope.row.name }}
                      </a>
                    </div>
                  </div>
                  <div>
                    {{ $t('product.id') }}: {{ scope.row.id }}
                  </div>
                  <div style="display: flex; gap: 20px; flex-wrap: wrap; margin-top: 20px; margin-bottom: 20px">
                    <div v-for="(i, index) in scope.row.new_url_list" :key="`item-${index}`"
                         style="width: 150px; height: 180px; max-width: 150px; max-height: 180px; margin-bottom: 10px; flex: 0 0 150px; border-radius: 5px; cursor: pointer"
                         @click.stop="m__click_attach_result_selected_list_checkbox(i)">
                      <div
                        class="image-item"
                        style="width: 100%; height: 150px; border-radius: 4px; overflow: hidden; border: 1px solid #eee; position: relative"
                        @click.stop="carousel_preview_list = scope.row.new_url_list; carousel_initial_index = index; show_dialog.carousel_preview_list = true">
                        <img :src="'https://cf.atosa.asia/public/images/' + i" alt=""
                             style="width: 100%; height: 100%; background-size: contain; object-fit: contain; max-width: 100%; max-height: 100%;">
                        <div
                          class="image-overlay"
                          style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; background-color: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; opacity: 0;">
                          <i class="el-icon-search" style="color: #fff; font-size: 20px; font-weight: bold"></i>
                        </div>
                      </div>
                      <div style="text-align: center; margin-top: 5px">
                        <el-checkbox :value="m__get_attach_result_selected_list_checkbox(i)"
                                     @change="m__click_attach_result_selected_list_checkbox(i)"></el-checkbox>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-else>
            <div>
              <div style="width: 750px; height: 20px; border-radius: 5px; display: flex; gap: 50px">
                <div style="flex: 1; display: flex; flex-direction: column; gap: 10px; height: 100%">
                  <strong class="strong-label">Ảnh cũ</strong>
                </div>
                <div style="flex: 1; display: flex; flex-direction: column; gap: 10px; height: 100%">
                  <strong class="strong-label">Ảnh mới</strong>
                </div>
              </div>
              <div style="width: 750px; height: 300px; border-radius: 5px; display: flex; gap: 50px">
                <div style="flex: 1; display: flex; flex-direction: column; gap: 10px; height: 100%">
                  <img :src="url_image_without_frame" alt=""
                       style="width: 100%; height: 100%; object-fit: contain"/>
                </div>
                <div style="flex: 1; display: flex; flex-direction: column; gap: 10px; height: 100%">
                  <img :src="url_image_with_frame" alt="" style="width: 100%; height: 100%; object-fit: contain"/>
                </div>
              </div>
            </div>

            <div
              v-if="add_frame_display === 'multiple' && attach_result_list.length && attach_result_list[0].new_url_list.length > 1"
              style="margin-top: 30px; padding-left: 20px">
              <p class="strong-label">{{ $t('product.select_image_to_add_frames') }}:</p>
              <div style="display: flex; gap: 20px; flex-wrap: wrap; margin-top: 10px">
                <template v-for="i in attach_result_list[0].new_url_list">
                  <div
                    style="width: 150px; height: 180px; max-width: 150px; max-height: 180px; margin-bottom: 10px; flex: 0 0 150px; border-radius: 5px; cursor: pointer"
                    @click.stop="m__click_attach_result_selected_list_checkbox(i)">
                    <div
                      class="image-item"
                      style="width: 100%; height: 150px; border-radius: 4px; overflow: hidden; border: 1px solid #eee; position: relative"
                      @click.stop="carousel_preview_list = scope.row.new_url_list; carousel_initial_index = index; show_dialog.carousel_preview_list = true">
                      <img :src="'https://cf.atosa.asia/public/images/' + i" alt=""
                           style="width: 100%; height: 100%; background-size: contain; object-fit: contain; max-width: 100%; max-height: 100%;">
                      <div
                        class="image-overlay"
                        style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; background-color: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; opacity: 0;">
                        <i class="el-icon-search" style="color: #fff; font-size: 20px; font-weight: bold"></i>
                      </div>
                    </div>
                    <div style="text-align: center; margin-top: 5px">
                      <el-checkbox :value="m__get_attach_result_selected_list_checkbox(i)"
                                   @change="m__click_attach_result_selected_list_checkbox(i)"></el-checkbox>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>

          <div style="margin-top: 40px; text-align: center">
            <template v-if="loading.preview_attach_frame">
              <el-button type="text" size="min">
                <strong class="text-primary"><i class="el-icon-loading text-primary"></i>
                  {{ $t('product.adding_frame') }}...
                </strong>
              </el-button>
            </template>
            <template v-else>
              <el-button type="info" size="mini" icon="el-icon-refresh" @click="selected_frame = null">
                {{ $t('product.use_other_frame') }}
              </el-button>
              <el-button type="primary" size="mini" icon="el-icon-check"
                         :loading="loading.attach_frame"
                         @click="m__confirm_attach_frame">
                {{ $t('product.confirm_add_frame') }}
              </el-button>
            </template>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.change_product_images_log" :close-on-click-modal="false" width="1400px">
      <div slot="title" style="padding:10px">
        <div>
          <p class="strong-title">
            {{ $t('product.history_edit_image_of') }}
            <strong class="text-primary" style="font-size: 14px">{{ selected_product.name }}</strong>
          </p>
        </div>

        <div style="margin-top: 60px">
          <el-table :data="change_product_images_log" default-expand-all>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div v-if="scope.row.is_expanded"
                     style="padding-top: 10px; padding-left: 10px; padding-bottom: 40px; background-color: #fff">
                  <!--                  <pre>{{ scope.row.product_metrics }}</pre>-->
                  <el-table :data="scope.row.product_metrics">
                    <el-table-column :label="$t('base.time')" width="150px">
                      <template slot-scope="scope">
                        {{ scope.row.label }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.sales_metrics')">
                      <el-table-column :label="$t('metric.impressions')">
                        <template slot-scope="scope">
                          {{ scope.row.performance.pv | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('metric.add_to_cart_units')">
                        <template slot-scope="scope">
                          {{ scope.row.performance.add_to_cart_units | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('metric.orders')">
                        <template slot-scope="scope">
                          {{ scope.row.performance.confirmed_order_per_buyers | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('base.sales')">
                        <template slot-scope="scope">
                          {{ scope.row.performance.confirmed_sales | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column label="AOV">
                        <template slot-scope="scope">
                          {{
                            scope.row.performance.confirmed_order_per_buyers ? m__calculate(scope.row.performance.confirmed_sales / scope.row.performance.confirmed_order_per_buyers) : 0 | currency
                          }}
                        </template>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column :label="$t('base.ads_metrics')">
                      <el-table-column :label="$t('metric.impressions')">
                        <template slot-scope="scope">
                          {{
                            scope.row.ads && scope.row.ads.impression ? +scope.row.ads.impression.value : 0 | currency
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('metric.clicks')">
                        <template slot-scope="scope">
                          {{ scope.row.ads && scope.row.ads.click ? +scope.row.ads.click.value : 0 | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('metric.orders')">
                        <template slot-scope="scope">
                          {{
                            scope.row.ads && scope.row.ads.broad_order ? +scope.row.ads.broad_order.value : 0 | currency
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('metric.expense')">
                        <template slot-scope="scope">
                          {{ scope.row.ads && scope.row.ads.cost ? +scope.row.ads.cost.value : 0 | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('base.sales')">
                        <template slot-scope="scope">
                          {{ scope.row.ads && scope.row.ads.broad_gmv ? +scope.row.ads.broad_gmv.value : 0 | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column label="CIR (ACOS)">
                        <template slot-scope="scope">
                          {{
                            scope.row.ads && scope.row.ads.broad_cir ? (+scope.row.ads.broad_cir.value * 100).toFixed(2) : 0 | currency
                          }}%
                        </template>
                      </el-table-column>
                      <el-table-column label="ROI (ROAS)">
                        <template slot-scope="scope">
                          {{ scope.row.ads && scope.row.ads.broad_roi ? +scope.row.ads.broad_roi.value : 0 | currency }}
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.updated_at')" width="140px">
              <template slot-scope="scope">
                <strong class="text-primary">{{ scope.row.created_at | moment('HH:mm DD/MM/YYYY') }}</strong>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="140px">
              <template slot-scope="scope">
                <strong>
                  <template v-if="scope.row.image_type === 'main'">{{ $t('product.edit_cover_image') }}</template>
                  <template v-if="scope.row.image_type === 'frame'">{{ $t('product.add_frame') }}</template>
                  <template v-if="scope.row.image_type === 'recovery'">{{ $t('product.recover_images') }}</template>
                  <template v-if="scope.row.image_type === 'delete_frame'">{{ $t('product.remove_frame') }}</template>
                </strong>
              </template>
            </el-table-column>
            <el-table-column width="450px" :label="$t('product.old_image')">
              <template slot-scope="scope">
                <div style="display: flex; gap: 20px; flex-wrap: wrap; margin-top: 10px">
                  <template v-for="i in scope.row.old_image_url_list">
                    <div
                      style="width: 65px; height: 65px; max-width: 65px; max-height: 65px; margin-bottom: 10px; flex: 0 0 80px; border-radius: 5px">
                      <div
                        style="width: 100%; height: 100%; border-radius: 4px; overflow: hidden; border: 1px solid #eee;">
                        <img :src="'https://cf.atosa.asia/public/images/' + i" alt=""
                             style="width: 100%; height: 100%; background-size: contain; object-fit: contain; max-width: 100%; max-height: 100%;">
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="450px" :label="$t('product.new_image')">
              <template slot-scope="scope">
                <div style="display: flex; gap: 20px; flex-wrap: wrap; margin-top: 10px">
                  <template v-for="i in scope.row.new_image_url_list">
                    <div
                      style="width: 65px; height: 65px; max-width: 65px; max-height: 65px; margin-bottom: 10px; flex: 0 0 80px; border-radius: 5px">
                      <div
                        style="width: 100%; height: 100%; border-radius: 4px; overflow: hidden; border: 1px solid #eee;">
                        <img :src="'https://cf.atosa.asia/public/images/' + i" alt=""
                             style="width: 100%; height: 100%; background-size: contain; object-fit: contain; max-width: 100%; max-height: 100%;">
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="140px" :label="$t('base.optional')" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__download_images(scope.row.old_image_url_list)">
                  <strong class="text-primary">{{ $t('base.download') }} {{ $t('product.old_image') }}</strong>
                </el-button>
                <br>
                <el-button type="text" size="mini" @click="m__download_images(scope.row.new_image_url_list)">
                  <strong class="text-primary">{{ $t('base.download') }} {{ $t('product.new_image') }}</strong>
                </el-button>
                <template v-if="scope.row.image_type === 'main'">
                  <br>
                  <el-button
                    :loading="loading.recovery_images"
                    type="text" size="mini" @click="m__recover_old_main_image(scope.row)">
                    <strong class="text-warning">{{ $t('product.recover_cover_image') }}</strong>
                  </el-button>
                </template>
                <template v-if="scope.row.image_type === 'frame'">
                  <br>
                  <el-button
                    :loading="loading.recovery_images"
                    type="text" size="mini" @click="m__recover_old_image_without_frame(scope.row)">
                    <strong class="text-warning">{{ $t('product.recover_old_image') }}</strong>
                  </el-button>
                  <br>
                  <el-button
                    :loading="loading.recovery_images"
                    type="text" size="mini" @click="m__show_delete_frame_dialog(scope.row)">
                    <strong class="text-warning">{{ $t('product.remove_frame') }}</strong>
                  </el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.replace_text_multiple" :close-on-click-modal="false" width="500px">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 14px">{{ $t('product.replace_text') }}</strong>

        <br>
        <br>

        <p class="text-title">{{ $t('product.expected_replace_text') }}:</p>
        <el-input size="mini" v-model="form_replace_text_multiple.text_search"
                  :placeholder="$t('input.replace_text')"></el-input>

        <br>
        <br>

        <p class="text-title">{{ $t('base.other_options') }}</p>
        <div style="padding-top: 3px; display: flex; gap: 10px;">
          <el-checkbox size="mini" v-model="form_replace_text_multiple.upper_case">
            <strong>{{ $t('product.uppercase_letter') }}</strong>
          </el-checkbox>
          <el-checkbox size="mini" v-model="form_replace_text_multiple.once">
            <strong>{{ $t('product.replace_first_only') }}</strong>
          </el-checkbox>
        </div>

        <br>

        <p class="text-title">{{ $t('product.replace_with') }}:</p>
        <el-input size="mini" v-model="form_replace_text_multiple.text_replace"
                  :placeholder="$t('input.new_text')"></el-input>

        <el-row style="margin-top: 30px">
          <el-col :span="12" style="padding-top: 5px; display: flex; align-items: center; gap: 5px">
            <input type="checkbox" v-model="ignore_review" style="margin: 0"></input>
            <div>{{ $t('product.skip_products_preview') }}</div>
          </el-col>
          <el-col :span="12" class="text-right">
            <el-button type="primary" icon="el-icon-check" size="mini" @click="m__review_replace_text_multiple_dialog"
                       :loading="loading.replace_text_multiple">
              {{ ignore_review ? $t('base.confirm') : $t('base.preview') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.change_name" :close-on-click-modal="false" width="800px">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 14px">{{ $t('product.edit_name') }}</strong>

        <br>
        <br>
        <br>

        <p class="text-title">{{ $t('product.current_name') }}:</p>
        <strong style="font-size: 13px" class="text-primary">
          {{ form_change_name.old_name }}</strong>
        &nbsp;&nbsp;
        <el-button type="text" @click="form_change_name.new_name = form_change_name.old_name">
          <i style="font-size: 13px;" class="el-icon-copy-document"></i>
        </el-button>
        <br>
        <br>

        <p class="text-title">{{ $t('product.new_name') }} ({{ form_change_name.new_name.length }}/120)</p>
        <el-input size="mini" v-model="form_change_name.new_name"></el-input>

        <div style="margin-top: 50px" class="text-right">
          <el-button type="primary" icon="el-icon-check" size="mini" @click="m__confirm_change_name"
                     :loading="loading.change_name">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.change_product_name_log" :close-on-click-modal="false" width="1350px">
      <div slot="title" style="padding:10px">
        <div>
          <p class="strong-title">
            {{ $t('product.history_edit_name_of') }}
            <strong class="text-primary" style="font-size: 14px">{{ selected_product.name }}</strong>
          </p>
        </div>

        <div style="margin-top: 60px">

          <el-table :data="change_product_name_log" default-expand-all>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div v-if="scope.row.is_expanded"
                     style="padding-top: 10px; padding-left: 10px; padding-bottom: 40px; background-color: #fff">
                  <el-table :data="scope.row.product_metrics">
                    <el-table-column :label="$t('base.time')" width="150px">
                      <template slot-scope="scope">
                        {{ scope.row.label }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.sales_metrics')">
                      <el-table-column :label="$t('metric.impressions')">
                        <template slot-scope="scope">
                          {{ scope.row.performance.pv | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('metric.add_to_cart_units')">
                        <template slot-scope="scope">
                          {{ scope.row.performance.add_to_cart_units | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('metric.orders')">
                        <template slot-scope="scope">
                          {{ scope.row.performance.confirmed_order_per_buyers | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('base.sales')">
                        <template slot-scope="scope">
                          {{ scope.row.performance.confirmed_sales | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column label="AOV">
                        <template slot-scope="scope">
                          {{
                            scope.row.performance.confirmed_order_per_buyers ? m__calculate(scope.row.performance.confirmed_sales / scope.row.performance.confirmed_order_per_buyers) : 0 | currency
                          }}
                        </template>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column :label="$t('base.ads_metrics')">
                      <el-table-column :label="$t('metric.impressions')">
                        <template slot-scope="scope">
                          {{
                            scope.row.ads && scope.row.ads.impression ? +scope.row.ads.impression.value : 0 | currency
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('metric.clicks')">
                        <template slot-scope="scope">
                          {{ scope.row.ads && scope.row.ads.click ? +scope.row.ads.click.value : 0 | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('metric.orders')">
                        <template slot-scope="scope">
                          {{
                            scope.row.ads && scope.row.ads.broad_order ? +scope.row.ads.broad_order.value : 0 | currency
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('metric.expense')">
                        <template slot-scope="scope">
                          {{ scope.row.ads && scope.row.ads.cost ? +scope.row.ads.cost.value : 0 | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('base.sales')">
                        <template slot-scope="scope">
                          {{ scope.row.ads && scope.row.ads.broad_gmv ? +scope.row.ads.broad_gmv.value : 0 | currency }}
                        </template>
                      </el-table-column>
                      <el-table-column label="CIR (ACOS)">
                        <template slot-scope="scope">
                          {{
                            scope.row.ads && scope.row.ads.broad_cir ? (+scope.row.ads.broad_cir.value * 100).toFixed(2) : 0 | currency
                          }}%
                        </template>
                      </el-table-column>
                      <el-table-column label="ROI (ROAS)">
                        <template slot-scope="scope">
                          {{ scope.row.ads && scope.row.ads.broad_roi ? +scope.row.ads.broad_roi.value : 0 | currency }}
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.updated_at')" width="140px">
              <template slot-scope="scope">
                <strong class="text-primary">{{ scope.row.created_at | moment('HH:mm DD/MM/YYYY') }}</strong>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="140px">
              <template slot-scope="scope">
                <strong class="text-warning">
                  <template v-if="scope.row.change_type === 'change_name'">{{ $t('product.change_name') }}</template>
                  <template v-if="scope.row.change_type === 'add_text'">{{ $t('product.add_text') }}</template>
                  <template v-if="scope.row.change_type === 'replace_text'">{{ $t('product.replace_text') }}</template>
                  <template v-if="scope.row.change_type === 'remove_text'">{{ $t('product.remove_text') }}</template>
                  <template v-if="scope.row.change_type === 'recovery_name'">{{ $t('product.recover_old_name') }}
                  </template>
                </strong>
              </template>
            </el-table-column>
            <el-table-column min-width="400px" :label="$t('product.old_name')">
              <template slot-scope="scope">
                {{ scope.row.old_name }}
              </template>
            </el-table-column>
            <el-table-column min-width="400px" :label="$t('product.new_name')">
              <template slot-scope="scope">
                {{ scope.row.new_name }}
              </template>
            </el-table-column>
            <el-table-column width="140px" :label="$t('base.optional')">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.change_type !== 'recovery_name'" :loading="loading.recovery_name"
                  type="text" size="mini" @click="m__recover_old_product_name(scope.row)">
                  <strong class="text-warning">{{ $t('product.recover_old_name') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.carousel_preview_list" :close-on-click-modal="false"
               :width="add_frame_display === 'all' ? '1200px' : '800px'">
      <div slot="title" style="padding:10px">
        <el-carousel arrow="always" :autoplay="false" :initial-index="carousel_initial_index" :interval="60 * 1000"
                     trigger="click">
          <el-carousel-item v-for="item in carousel_preview_list" :key="item">
            <img :src="'https://cf.atosa.asia/public/images/' +  item" alt=""
                 style="width: 100%; height: 100%; object-fit: contain">
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.delete_frame" :close-on-click-modal="false" width="1200px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('product.remove_frame') }}</strong>

        <div style="margin-top: 30px">
          <div style="width: 50%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
            <a href="javascript:void(0)"
               @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${selected_product  ? selected_product.id : ''}`, shop)">
              {{ selected_product ? selected_product.name : '' }}
            </a>
          </div>
        </div>
        <div>
          {{ $t('product.id') }}: {{ selected_product ? selected_product.id : '' }}
        </div>
        <div style="display: flex; gap: 20px; flex-wrap: wrap; margin-top: 20px; margin-bottom: 20px">
          <div v-for="(i, index) in images_map_log" :key="`item-${index}`"
               style="width: 150px; height: 180px; max-width: 150px; max-height: 180px; margin-bottom: 10px; flex: 0 0 150px; border-radius: 5px; cursor: pointer"
               @click.stop="m__click_attach_result_selected_list_checkbox(i.new)">
            <div
              class="image-item"
              style="width: 100%; height: 150px; border-radius: 4px; overflow: hidden; border: 1px solid #eee; position: relative">
              <img :src="SHOPEE_IMAGE(i.new)" alt=""
                   style="width: 100%; height: 100%; background-size: contain; object-fit: contain; max-width: 100%; max-height: 100%;">
              <div
                class="image-overlay"
                style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; background-color: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; opacity: 0;">
                <i class="el-icon-search" style="color: #fff; font-size: 20px; font-weight: bold"></i>
              </div>
            </div>
            <div style="text-align: center; margin-top: 5px">
              <el-checkbox :value="m__get_attach_result_selected_list_checkbox(i.new)"
                           @change="m__click_attach_result_selected_list_checkbox(i.new)"></el-checkbox>
            </div>
          </div>
        </div>

        <div style="margin-top: 40px; text-align: center">
          <el-button type="primary" size="mini" :loading="loading.delete_frame" @click="m__confirm_delete_frame">
            {{ $t('product.remove_frame') }} ({{ attach_result_selected_list.length }})
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.delete_frame_multiple" :close-on-click-modal="false" width="1200px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('product.mass_remove_frame') }}</strong>

        <el-table :data="delete_frame_multiple_list">
          <el-table-column>
            <template slot-scope="scope">
              <div style="margin-top: 30px">
                <div style="width: 50%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                  <a href="javascript:void(0)"
                     @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                    {{ scope.row.name }}
                  </a>
                </div>
              </div>
              <div>
                {{ $t('product.id') }}: {{ scope.row.id }}
              </div>
              <div style="display: flex; gap: 40px; flex-wrap: wrap; margin-top: 20px; margin-bottom: 20px">
                <div
                  style="width: 250px; height: 180px; max-width: 250px; max-height: 180px; margin-bottom: 10px; flex: 0 0 250px; border-radius: 5px; cursor: pointer">
                  <div style="font-size: 13px; margin-bottom: 10px">{{ $t('product.current_cover_image') }}</div>
                  <div
                    class="image-item"
                    style="width: 150px; height: 150px; border-radius: 4px; overflow: hidden; border: 1px solid #eee; position: relative">
                    <img :src="SHOPEE_IMAGE(scope.row.current_image)" alt=""
                         style="width: 150px; height: 100%; background-size: contain; object-fit: contain; max-width: 100%; max-height: 100%;">
                    <div
                      class="image-overlay"
                      style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; background-color: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; opacity: 0;">
                      <i class="el-icon-search" style="color: #fff; font-size: 20px; font-weight: bold"></i>
                    </div>
                  </div>
                </div>

                <div
                  style="width: 250px; height: 180px; max-width: 250px; max-height: 180px; margin-bottom: 10px; flex: 0 0 250px; border-radius: 5px; cursor: pointer">
                  <div style="font-size: 13px; margin-bottom: 10px">{{
                      $t('product.cover_image_after_remove_frame')
                    }}
                  </div>
                  <div
                    class="image-item"
                    style="width: 150px; height: 150px; border-radius: 4px; overflow: hidden; border: 1px solid #eee; position: relative">
                    <img :src="SHOPEE_IMAGE(scope.row.recover_image)" alt=""
                         style="width: 150px; height: 100%; background-size: contain; object-fit: contain; max-width: 100%; max-height: 100%;">
                    <div
                      class="image-overlay"
                      style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; background-color: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; opacity: 0;">
                      <i class="el-icon-search" style="color: #fff; font-size: 20px; font-weight: bold"></i>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div style="margin-top: 40px; text-align: center">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.delete_frame_multiple"
                     @click="m__confirm_delete_frame_multiple">
            {{ $t('product.remove_frame') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <input accept='text/plain' type="file" @change="m__import_file" id="input_control_detail" style="display: none;">
  </div>
</template>

<script>
import {
  drop as _drop,
  filter as _filter,
  orderBy as _orderBy,
  pick as _pick,
  take as _take,
  chunk as _chunk
} from 'lodash'
import {check_channel, check_feature, show_expr_notification} from '../../addon/check_license'
import {create_file_from_url, get_base64} from '../../addon/function'
import {get_shop_mixins} from '../../mixins/get_shop';
import {fix_ads_mixins} from "../../mixins/fix_ads";
import {after_n_char_fixed_list} from "../../addon/fixed_list";

export default {
  name: 'page__shop-product',

  mixins: [get_shop_mixins, fix_ads_mixins],

  components: {},

  data() {
    return {
      page_key: new Date().getTime(),

      filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        pages: [10, 20, 30, 40, 50, 100],
        group_id: ''
      },
      review_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        pages: [10, 20, 30, 40, 50, 100]
      },
      seller: {},
      loading: {
        get_product: false,
        update_on_review: false,
        add_text_multiple: false,
        remove_text_multiple: false,
        add_group: false,
        add_product_to_group: false,
        add_restricted_keyword: false,
        update_restricted_keyword: false,
        update_keyword: false,
        add_product_to_restricted_keyword: false,
        upload_image: false,
        attach_frame: false,
        preview_attach_frame: false,
        change_product_images_log: false,
        change_product_name_log: false,
        replace_text_multiple: false,
        recovery_images: false,
        recovery_name: false,
        change_name: false,
        delete_frame: false,
        delete_frame_multiple: false
      },
      show_dialog: {
        add_text_multiple: false,
        remove_text_multiple: false,
        review_product: false,
        add_group: false,
        add_product_to_group: false,
        add_restricted_keyword: false,
        update_keyword: false,
        add_product_to_restricted_keyword: false,
        upload_image: false,
        attach_frame: false,
        change_product_images_log: false,
        change_product_name_log: false,
        replace_text_multiple: false,
        change_name: false,
        carousel_preview_list: false,
        delete_frame: false,
        delete_frame_multiple: false,
      },
      product_list: [],
      product_clone_list: [],
      review_list: [],
      form_add_text_multiple: {
        text: '',
        position: 'end',
        n_char: 1
      },
      form_remove_text_multiple: {
        text: '',
        regex: '',
        is_regex: false,
        upper_case: false,
        once: false
      },
      form_replace_text_multiple: {
        text_search: '',
        text_replace: '',
        regex: '',
        is_regex: false,
        upper_case: false,
        once: false
      },
      ignore_review: false,
      action: '',
      product_sort_option: {
        order: null,
        prop: null
      },
      tab: 'product',

      group_list: [],
      form_group: {
        id: null,
        name: '',
        groupId: null,
        productIds: []
      },
      selected_group_id: null,

      restricted_keyword: '',
      restricted_keywords: [],
      form_restricted_keyword: {
        id: null,
        name: '',
        keywords: [],
        productIds: []
      },
      selected_restricted_keyword_id: null,

      restricted_keyword_fixed_list: [
        'vuducminhdev07',
        '0934824608'
      ],

      selected_product: {},
      preview_image: null,
      preview_image_url: null,
      image_list: [],
      allow_replace_first: true,
      frame_display_type: 'all',
      default_frame_list: [
        {
          url: 'https://static.atosa.asia/frames/f1.png',
          name: this.$t('base.frame_image') + ' f1',
          filename: this.$t('base.frame') + ' f1.png'
        },
        {
          url: 'https://static.atosa.asia/frames/f2.png',
          name: this.$t('base.frame_image') + ' f2',
          filename: this.$t('base.frame') + ' f2.png'
        },
        {
          url: 'https://static.atosa.asia/frames/f3.png',
          name: this.$t('base.frame_image') + ' f3',
          filename: this.$t('base.frame') + ' f3.png'
        },
        {
          url: 'https://static.atosa.asia/frames/f4.png',
          name: this.$t('base.frame_image') + ' f4',
          filename: this.$t('base.frame') + ' f4.png'
        },
        {
          url: 'https://static.atosa.asia/frames/f5.png',
          name: this.$t('base.frame_image') + ' f5',
          filename: this.$t('base.frame') + ' f5.png'
        },
        {
          url: 'https://static.atosa.asia/frames/f6.png',
          name: this.$t('base.frame_image') + ' f6',
          filename: this.$t('base.frame') + ' f6.png'
        },
        {
          url: 'https://static.atosa.asia/frames/f7.png',
          name: this.$t('base.frame_image') + ' f7',
          filename: this.$t('base.frame') + ' f7.png'
        },
        {
          url: 'https://static.atosa.asia/frames/f8.png',
          name: this.$t('base.frame_image') + ' f8',
          filename: this.$t('base.frame') + ' f8.png'
        },
        {
          url: 'https://static.atosa.asia/frames/f9.png',
          name: this.$t('base.frame_image') + ' f9',
          filename: this.$t('base.frame') + ' f9.png'
        },
        {
          url: 'https://static.atosa.asia/frames/f10.png',
          name: this.$t('base.frame_image') + ' f10',
          filename: this.$t('base.frame') + ' f10.png'
        }
      ],
      default_frame_full_list: [],
      frame_list: [],
      show_full_frame: false,
      selected_frame: '',
      attach_frame_type: 'main',
      url_image_without_frame: '',
      url_image_with_frame: '',
      attach_result_list: [],
      attach_result_selected_list: [],
      change_product_images_log: [],
      change_product_name_log: [],
      form_change_name: {
        old_name: '',
        new_name: ''
      },
      add_frame_display: 'all',
      carousel_preview_list: [],
      carousel_initial_index: 0,
      show_full_attach_frame_display: false,
      selected_log: null,
      images_map_log: [],

      delete_frame_multiple_list: [],

      period: 'past30days',

      past7days_data: [],
      past30days_data: [],

      interval: null,

      after_n_char_fixed_list
    }
  },

  beforeRouteEnter(to, from, next) {
    if (/*check_feature('keyword_tool') || */check_feature('flash_sale') || check_channel('shopee_marketing_fs')) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    this.default_frame_full_list = this.clone(this.default_frame_list)
    for (let i = 1; i <= 91; i++) {
      this.default_frame_full_list.push({
        url: `https://static.atosa.asia/frames/khung ${i}.png`,
        name: `${this.$t('base.frame_image')} ${i}`,
        filename: `${this.$t('base.frame')} ${i}.png`
      })
    }

    await this.m__get_shopee_shop()
    await this.m__get_frames()

    // todo: test
    // const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
    //   shop_id: this.shop.shop_id,
    //   data: {
    //     method: 'POST',
    //     uri: 'payment/get_escrow_detail_batch',
    //     params: {
    //       order_sn: '25051995WC64P4'
    //     }
    //   }
    // }, this.cf())
    // console.log(update_response)
  },

  async beforeDestroy() {
    if (this.interval) clearInterval(this.interval)
  },

  watch: {
    'shopee_shop.selected': function () {
      this.page_key = new Date().getTime()
      this.m__initial_view()
    }
  },

  computed: {
    list_true() {
      let result = this.product_list

      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      if (this.filter.group_id) {
        result = result.filter(i => i.group_id === this.filter.group_id)
      }

      const words = this.remove_unicode(this.filter.keyword).split(',')
      const pattern = words.map(w => this.escape_regex(w)).join('|');
      const regex = new RegExp(pattern);

      return result.filter(item => {
        const string = this.remove_unicode(JSON.stringify({
          id: item.id,
          name: item.name.normalize()
        }))
        return regex.test(string)
      })
    },

    list_display() {
      const limit = this.filter.page_size
      const skip = limit * (this.filter.current_page - 1)

      return _take(_drop(this.list_true, skip), limit)
    },

    review_list_display() {
      const limit = this.review_filter.page_size
      const skip = limit * (this.review_filter.current_page - 1)

      return _take(_drop(this.review_list, skip), limit)
    },

    frame_list_display() {
      if (this.frame_display_type === 'all') {
        if (this.show_full_frame) {
          return [...this.default_frame_full_list, ...this.frame_list]
        } else {
          return [...this.default_frame_list, ...this.frame_list, {more: true}]
        }
      }

      if (this.frame_display_type === 'sale') {
        const true_list = [
          this.$t('base.frame') + ' 4.',
          this.$t('base.frame') + ' 20.',
          this.$t('base.frame') + ' 31.',
          this.$t('base.frame') + ' 33.',
          this.$t('base.frame') + ' 35.',
          this.$t('base.frame') + ' 53.',
          this.$t('base.frame') + ' 60.',
          this.$t('base.frame') + ' 27.',
          this.$t('base.frame') + ' 28.',
          this.$t('base.frame') + ' 33.',
          this.$t('base.frame') + ' 39.',
          this.$t('base.frame') + ' 42.',
          this.$t('base.frame') + ' 45.',
          this.$t('base.frame') + ' 55.',
          this.$t('base.frame') + ' 56.'
        ]
        return this.default_frame_full_list.filter(i => true_list.some(ii => i.filename.includes(ii)))
      }
    }
  },

  methods: {
    m__add_text_after_n_characters(original_text, insert_text, position) {
      if (!insert_text || !position || position < 0) return original_text

      const words = original_text.split(' ')

      const insert_index = Math.min(position, words.length)

      const new_text = [
        ...words.slice(0, insert_index),
        insert_text,
        ...words.slice(insert_index)
      ]

      return new_text.join(' ')
    },

    m__generate_scrollbar() {
      this.$nextTick(() => {
        try {
          const dashboard_wrapper = document.getElementById('dashboard-wrapper')

          const main_table = document.querySelector('div#main-table')
          const main_table_fixed = document.querySelector('div#main-table-fixed-header')
          const main_table_wrapper = document.querySelector('div#main-table div.el-table__body-wrapper')
          const main_table_wrapper_fixed = document.querySelector('div#main-table-fixed-header div.el-table__header-wrapper')

          this.interval = setInterval(() => {
            main_table_fixed.style.width = main_table.scrollWidth + 'px'
          }, 1000)
          main_table_wrapper.onscroll = () => {
            main_table_wrapper_fixed.scrollLeft = main_table_wrapper.scrollLeft
          }

          const bounding_main_pagination = () => {
            const rect2 = main_table_wrapper.getBoundingClientRect()
            const elem_top2 = rect2.top
            const elem_bot2 = rect2.bottom
            if (elem_top2 > 0 || elem_bot2 <= 100) {
              main_table_fixed.style.zIndex = '-1'
            } else {
              main_table_fixed.style.zIndex = '2000'
            }
          }
          bounding_main_pagination()

          dashboard_wrapper.onscroll = () => {
            bounding_main_pagination()
          }
        } catch (e) {
        }
      })
    },

    async m__confirm_delete_frame_multiple() {
      try {
        await this.$confirm(this.$t('product.delete_frame_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.delete_frame_multiple = true
      try {
        for (const item of this.delete_frame_multiple_list) {
          const new_image = await create_file_from_url(this.SHOPEE_IMAGE(item.recover_image), item.recover_image)
          const response = await this.seller.upload_image(new_image)
          if (response && response.data && response.data.data && response.data.data.resource_id) {
            const product_images = this.clone(item.images)
            product_images[product_images.indexOf(item.current_image)] = response.data.data.resource_id

            // old_image_url_list.push(this.SHOPEE_IMAGE(current_image))
            // new_image_url_list.push(this.SHOPEE_IMAGE(response.data.data.resource_id))
            // images_map.push({old: current_image, new: response.data.data.resource_id})

            const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
              shop_id: this.shop.shop_id,
              data: {
                method: 'POST',
                uri: 'product/update_item',
                body: {
                  item_id: item.id,
                  image: {
                    image_id_list: product_images
                  }
                }
              }
            }, this.cf())
            console.log(item.id, '-', 'update_response delete frame:', update_response.body)
          }
        }

        await this.m__get_products()
        this.show_dialog.delete_frame_multiple = false
        this.ntf_s(this.$t('product.delete_frame_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.delete_frame_multiple = false
      }
    },

    async m__show_delete_frame_multiple_dialog() {
      if (!this.list_true.filter(i => i.checked === true).length) {
        this.ntf_w(this.$t('required.select_product'))
        return
      }

      this.delete_frame_multiple_list = []
      this.loading.delete_frame_multiple = true

      for (const product of this.list_true.filter(i => i.checked === true)) {
        const response = await this.$http.get('https://cf.atosa.asia/api/image/log/' + product.id, this.cf())
        const filter_list = response.body.data.filter(i => i.image_type === 'frame' && i.change_type === 'main')
        if (!filter_list || !filter_list.length) continue

        this.delete_frame_multiple_list.push({
          ...product,
          current_image: product.images[0],
          recover_image: filter_list[0].images_map[0].old
        })
      }

      this.loading.delete_frame_multiple = false
      this.show_dialog.delete_frame_multiple = true
    },

    async m__confirm_delete_frame() {
      if (!this.attach_result_selected_list.length) {
        this.ntf_w(this.$t('required.select_image_to_remove_frame'))
        return
      }

      try {
        await this.$confirm(this.$t('product.delete_frame_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.delete_frame = true
      const product_images = this.selected_product.images
      try {
        const old_image_url_list = []
        const new_image_url_list = []
        const new_images_map = []
        for (const item of this.selected_log.images_map) {
          if (!this.attach_result_selected_list.includes(item.new)) continue

          const old_image = await create_file_from_url(this.SHOPEE_IMAGE(item.old), item.old)
          const response = await this.seller.upload_image(old_image)
          if (response && response.data && response.data.data && response.data.data.resource_id) {
            product_images[product_images.indexOf(item.new)] = response.data.data.resource_id
            old_image_url_list.push(this.SHOPEE_IMAGE(item.new))
            new_image_url_list.push(this.SHOPEE_IMAGE(response.data.data.resource_id))
            new_images_map.push({
              old: item.new,
              new: response.data.data.resource_id
            })
          }
        }

        const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
          shop_id: this.shop.shop_id,
          data: {
            method: 'POST',
            uri: 'product/update_item',
            body: {
              item_id: this.selected_product.id,
              image: {
                image_id_list: product_images
              }
            }
          }
        }, this.cf())
        console.log(this.selected_product.id, '-', 'update_response delete frame:', update_response.body)

        await this.m__get_products()
        this.show_dialog.delete_frame = false
        this.ntf_s(this.$t('product.delete_frame_success'))

        this.m__get_product_metrics(this.selected_product)
          .then(product_metrics => {
            const log = {
              shop_id: this.shop.shop_id,
              product_id: this.selected_product.id,
              old_image_url_list: old_image_url_list,
              new_image_url_list: new_image_url_list,
              image_type: 'delete_frame',
              change_type: 'frame',
              api_response: JSON.stringify(update_response.body),
              allow_replace_first: this.allow_replace_first,
              product_metrics: product_metrics,
              images_map: new_images_map,
              origin_product: JSON.stringify(this.selected_product)
            }
            this.$http.post('https://cf.atosa.asia/api/image/log', log, this.cf()).catch(console.error)
          })
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.delete_frame = false
      }
    },

    m__show_delete_frame_dialog(log) {
      this.selected_product = this.product_list.find(i => i.id === log.product_id)
      this.attach_result_selected_list = log.images_map.map(i => i.new)

      this.selected_log = log
      this.images_map_log = log.images_map
      this.show_dialog.delete_frame = true
    },

    m__get_attach_result_selected_list_checkbox(image) {
      return this.attach_result_selected_list.includes(image)
    },

    m__click_attach_result_selected_list_checkbox(image) {
      if (this.attach_result_selected_list.includes(image)) {
        this.attach_result_selected_list = this.attach_result_selected_list.filter(i => i !== image)
      } else {
        this.attach_result_selected_list.push(image)
      }
    },

    m__on_expand_change(row, expanded) {
      const found = expanded.find(i => i._id === row._id)
      if (found) {
        found.is_expanded = true
      }
    },

    async m__recover_old_product_name(log) {
      try {
        await this.$confirm(this.$t('product.recover_old_name_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      if (!log.old_name) return

      this.loading.recovery_name = true
      try {
        const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
          shop_id: this.shop.shop_id,
          data: {
            method: 'POST',
            uri: 'product/update_item',
            body: {
              item_id: log.product_id,
              item_name: log.old_name
            }
          }
        }, this.cf())

        const result = update_response.body.data
        if (!result.error) {
          await this.m__get_products()
          this.ntf_s(this.$t('base.update_product_name_success'))
          this.show_dialog.change_product_name_log = false

          // todo: save log
          this.m__get_product_metrics(this.selected_product)
            .then(product_metrics => {
              const new_log = {
                shop_id: this.shop.shop_id,
                product_id: this.selected_product.id,
                old_name: '',
                new_name: log.old_name,
                change_type: 'change_name',
                api_response: JSON.stringify(update_response.body),
                product_metrics: product_metrics
              }
              this.$http.post('https://cf.atosa.asia/api/name/log', new_log, this.cf()).catch(console.error)
            })
        } else {
          this.ntf_w(`${this.$t('base.has_an_occurred')}. ${this.$t('base.error_code')}: ${result.message}`)
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.recovery_name = false
      }
    },

    async m__get_change_product_name_log(product) {
      this.selected_product = product
      this.loading.change_product_name_log = true
      const response = await this.$http.get('https://cf.atosa.asia/api/name/log/' + product.id, this.cf())
      for (const item of response.body.data) {
        item.is_expanded = true
      }
      this.change_product_name_log = response.body.data
      this.loading.change_product_name_log = false
      this.show_dialog.change_product_name_log = true
    },

    async m__confirm_change_name() {
      if (!this.form_change_name.new_name) {
        this.ntf_w(this.$t('required.new_product_name'))
        return
      }

      try {
        await this.$confirm(this.$t('product.change_name_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.change_name = true
      try {
        const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
          shop_id: this.shop.shop_id,
          data: {
            method: 'POST',
            uri: 'product/update_item',
            body: {
              item_id: this.selected_product.id,
              item_name: this.form_change_name.new_name
            }
          }
        }, this.cf())

        const result = update_response.body.data
        if (!result.error) {
          await this.m__get_products()
          this.ntf_s(this.$t('base.update_product_name_success'))
          this.show_dialog.change_name = false

          // todo: save log
          this.m__get_product_metrics(this.selected_product)
            .then(product_metrics => {
              const log = {
                shop_id: this.shop.shop_id,
                product_id: this.selected_product.id,
                old_name: this.form_change_name.old_name,
                new_name: this.form_change_name.new_name,
                change_type: 'change_name',
                api_response: JSON.stringify(update_response.body),
                product_metrics: product_metrics,
                origin_product: JSON.stringify(this.selected_product)
              }
              this.$http.post('https://cf.atosa.asia/api/name/log', log, this.cf()).catch(console.error)
            })
        } else {
          this.ntf_w(`${this.$t('base.has_an_occurred')}. ${this.$t('base.error_code')}: ${result.message}`)
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.change_name = false
      }
    },

    m__show_dialog_change_name(product) {
      this.selected_product = product

      this.form_change_name.old_name = product.name
      this.form_change_name.new_name = ''

      this.show_dialog.change_name = true
    },

    async m__recover_old_image_without_frame(log) {
      if (!log.images_map) {
        this.ntf_w(this.$t('product.cannot_recover_old_image'))
        return
      }

      try {
        await this.$confirm(this.$t('product.recover_old_image_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.recovery_images = true
      try {
        const product_found = this.product_list.find(i => i.id === log.product_id)

        const old_image_url_list = []
        const new_image_url_list = []
        const images_map = []
        for (const image of log.images_map) {
          const current_image = product_found.images.find(i => i === image.new)
          if (current_image) {
            const new_image = await create_file_from_url(this.SHOPEE_IMAGE(image.old), image.old)
            const response = await this.seller.upload_image(new_image)
            if (response && response.data && response.data.data && response.data.data.resource_id) {
              product_found.images[product_found.images.indexOf(current_image)] = response.data.data.resource_id

              old_image_url_list.push(this.SHOPEE_IMAGE(current_image))
              new_image_url_list.push(this.SHOPEE_IMAGE(response.data.data.resource_id))
              images_map.push({
                old: current_image,
                new: response.data.data.resource_id
              })
            }
          }
        }

        const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
          shop_id: this.shop.shop_id,
          data: {
            method: 'POST',
            uri: 'product/update_item',
            body: {
              item_id: product_found.id,
              image: {
                image_id_list: product_found.images
              }
            }
          }
        }, this.cf())
        console.log(product_found.id, '-', 'update_response recover frame:', update_response.body)

        await this.m__get_products()
        const product_metrics = await this.m__get_product_metrics(product_found)
        const new_log = {
          shop_id: this.shop.shop_id,
          product_id: product_found.id,
          old_image_url_list: old_image_url_list,
          new_image_url_list: new_image_url_list,
          image_type: 'recovery',
          change_type: 'frame',
          api_response: JSON.stringify(update_response.body),
          allow_replace_first: this.allow_replace_first,
          product_metrics: product_metrics,
          images_map: images_map
        }
        this.$http.post('https://cf.atosa.asia/api/image/log', new_log, this.cf()).catch(console.error)
        this.ntf_s(this.$t('product.recover_image_success'))
        this.show_dialog.change_product_images_log = false
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
      this.loading.recovery_images = false
    },

    async m__recover_old_main_image(log) {
      try {
        await this.$confirm(this.$t('product.recover_old_image_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.recovery_images = true
      try {
        const new_image = await create_file_from_url('https://cf.atosa.asia/public/images/' + log.old_image_url_list[0], log.old_image_url_list[0])
        const response = await this.seller.upload_image(new_image)
        if (response && response.data && response.data.data && response.data.data.resource_id) {
          const resource_id = response.data.data.resource_id
          const product_found = this.product_list.find(i => i.id === log.product_id)
          const product_images = this.clone(product_found.images)
          if (this.allow_replace_first) {
            product_images.shift()
          }

          const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
            shop_id: this.shop.shop_id,
            data: {
              method: 'POST',
              uri: 'product/update_item',
              body: {
                item_id: product_found.id,
                image: {
                  image_id_list: [resource_id, ...product_images]
                }
              }
            }
          }, this.cf())
          console.log(product_found.id, '-', 'update_response main:', update_response.body)

          const result = update_response.body.data
          if (!result.error) {
            await this.m__get_products()

            const product_metrics = await this.m__get_product_metrics(product_found)
            const new_log = {
              shop_id: this.shop.shop_id,
              product_id: product_found.id,
              old_image_url_list: [this.SHOPEE_IMAGE(product_found.images[0])],
              new_image_url_list: [this.SHOPEE_IMAGE(resource_id)],
              image_type: 'recovery',
              change_type: 'main',
              api_response: JSON.stringify(update_response.body),
              allow_replace_first: this.allow_replace_first,
              product_metrics: product_metrics
            }
            this.$http.post('https://cf.atosa.asia/api/image/log', new_log, this.cf()).catch(console.error)

            this.ntf_s(this.$t('product.recover_image_success'))
            this.show_dialog.change_product_images_log = false
          } else {
            this.ntf_w(`${this.$t('base.has_an_occurred')}. ${this.$t('base.error_code')}: ${result.message}`)
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
      this.loading.recovery_images = false
    },

    async m__get_product_metrics(product) {
      let start_time, end_time, get_product_performance_response, campaign_list, period

      start_time = this.dayjs().startOf('day').unix()
      end_time = this.dayjs().endOf('day').unix()
      period = 'real_time'
      const today = {
        label: this.$t('product.current_time'),
        start_time: start_time,
        end_time: end_time,
        performance: null,
        ads: null,
        created_time: this.dayjs().unix()
      }
      get_product_performance_response = await this.seller.get_product_performance_main(1, 20, start_time, end_time, period, product.name)
      // console.log('get_product_performance_response', get_product_performance_response)
      if (get_product_performance_response && get_product_performance_response.data && get_product_performance_response.data.result && get_product_performance_response.data.result.items) {
        const found = get_product_performance_response.data.result.items.find(i => i.id = product.id)
        today.performance = found || {}
      }
      campaign_list = await this.seller.marketing_get_search_ads(start_time * 1000, end_time * 1000, 0, 20, 'ongoing', product.id)
      // console.log('campaign_list', campaign_list)
      if (campaign_list && campaign_list.length) {
        const found = campaign_list.find(i => i.product.itemid === product.id)
        today.ads = found ? found.report : {}
      }

      // todo: yesterday
      start_time = this.dayjs().subtract(1, 'day').startOf('day').unix()
      end_time = this.dayjs().subtract(1, 'day').endOf('day').unix()
      period = 'yesterday'
      const yesterday = {
        label: this.$t('base.previous_day'),
        start_time: start_time,
        end_time: end_time,
        performance: null,
        ads: null,
        created_time: this.dayjs().unix()
      }
      get_product_performance_response = await this.seller.get_product_performance_main(1, 20, start_time, end_time + 1, period, product.name)
      // console.log('get_product_performance_response', get_product_performance_response)
      if (get_product_performance_response && get_product_performance_response.data && get_product_performance_response.data.result && get_product_performance_response.data.result.items) {
        const found = get_product_performance_response.data.result.items.find(i => i.id = product.id)
        yesterday.performance = found || {}
      }
      campaign_list = await this.seller.marketing_get_search_ads(start_time * 1000, end_time * 1000, 0, 20, 'ongoing', product.id)
      // console.log('campaign_list', campaign_list)
      if (campaign_list && campaign_list.length) {
        const found = campaign_list.find(i => i.product.itemid === product.id)
        yesterday.ads = found ? found.report : {}
      }

      // todo: past7days
      start_time = this.dayjs().subtract(7, 'day').startOf('day').unix()
      end_time = this.dayjs().startOf('day').unix()
      period = 'past7days'
      const past7days = {
        label: this.$t('day.past7days'),
        start_time: start_time,
        end_time: end_time,
        performance: null,
        ads: null,
        created_time: this.dayjs().unix()
      }
      get_product_performance_response = await this.seller.get_product_performance_main(1, 20, start_time, end_time, period, product.name)
      // console.log('get_product_performance_response', get_product_performance_response)
      if (get_product_performance_response && get_product_performance_response.data && get_product_performance_response.data.result && get_product_performance_response.data.result.items) {
        const found = get_product_performance_response.data.result.items.find(i => i.id = product.id)
        past7days.performance = found || {}
      }
      campaign_list = await this.seller.marketing_get_search_ads(start_time * 1000, end_time * 1000, 0, 20, 'ongoing', product.id)
      // console.log('campaign_list', campaign_list)
      if (campaign_list && campaign_list.length) {
        const found = campaign_list.find(i => i.product.itemid === product.id)
        past7days.ads = found ? found.report : {}
      }

      // todo: past30days
      start_time = this.dayjs().subtract(30, 'day').startOf('day').unix()
      end_time = this.dayjs().startOf('day').unix()
      period = 'past30days'
      const past30days = {
        label: this.$t('day.past30days'),
        start_time: start_time,
        end_time: end_time,
        performance: null,
        ads: null,
        created_time: this.dayjs().unix()
      }
      get_product_performance_response = await this.seller.get_product_performance_main(1, 20, start_time, end_time, period, product.name)
      // console.log('get_product_performance_response', get_product_performance_response)
      if (get_product_performance_response && get_product_performance_response.data && get_product_performance_response.data.result && get_product_performance_response.data.result.items) {
        const found = get_product_performance_response.data.result.items.find(i => i.id = product.id)
        past30days.performance = found || {}
      }
      campaign_list = await this.seller.marketing_get_search_ads(start_time * 1000, end_time * 1000, 0, 20, 'ongoing', product.id)
      // console.log('campaign_list', campaign_list)
      if (campaign_list && campaign_list.length) {
        const found = campaign_list.find(i => i.product.itemid === product.id)
        past30days.ads = found ? found.report : {}
      }

      return [today, yesterday, past7days, past30days]
    },

    async m__confirm_replace_text_multiple() {
      if (!this.form_replace_text_multiple.text_search) {
        this.ntf_w(this.$t('required.replace_text'))
        return
      }
      if (!this.form_replace_text_multiple.text_replace) {
        this.ntf_w(this.$t('required.new_replace_text'))
        return
      }

      this.loading.replace_text_multiple = true

      try {
        await this.$confirm(this.$t('base.change_product_name_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })

        const checked_product = this.list_true.filter(i => i.checked === true)
        for (const product of checked_product) {
          const old_name = product.name

          let flags = ''
          if (!this.form_replace_text_multiple.upper_case) flags += 'i'
          if (!this.form_replace_text_multiple.once) flags += 'g'
          const reg = new RegExp(this.m__escape_regex(this.form_replace_text_multiple.text_search), flags)
          product.name = product.name.replace(reg, this.form_replace_text_multiple.text_replace).trim()

          const data = _pick(product, ['id', 'name'])

          const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
            shop_id: this.shop.shop_id,
            data: {
              method: 'POST',
              uri: 'product/update_item',
              body: {
                item_id: data.id,
                item_name: data.name
              }
            }
          }, this.cf())

          const review_found = this.review_list.find(i => i.id === product.id)
          if (review_found && update_response && update_response.body) {
            review_found.update_status = update_response.body.data.error === ''
            review_found.update_message = update_response.body.data.error === '' ? this.$t('base.update_success') : update_response.body.data.message

            // todo: save log
            this.m__get_product_metrics(product)
              .then(product_metrics => {
                const log = {
                  shop_id: this.shop.shop_id,
                  product_id: data.id,
                  old_name: old_name,
                  new_name: product.name,
                  change_type: 'replace_text',
                  api_response: JSON.stringify(update_response.body),
                  product_metrics: product_metrics,
                  origin_product: JSON.stringify(product)
                }
                this.$http.post('https://cf.atosa.asia/api/name/log', log, this.cf()).catch(console.error)
              })
          }
        }

        this.show_dialog.review_product = false
        this.show_dialog.replace_text_multiple = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.log(e)
      } finally {
        this.loading.replace_text_multiple = false
      }
    },

    async m__review_replace_text_multiple_dialog() {
      if (this.ignore_review) {
        await this.m__confirm_replace_text_multiple()
      } else {
        this.review_list = []

        const checked_product = this.list_true.filter(i => i.checked === true)
        for (const product of checked_product) {
          let flags = ''
          if (!this.form_replace_text_multiple.upper_case) flags += 'i'
          if (!this.form_replace_text_multiple.once) flags += 'g'
          const reg = new RegExp(this.m__escape_regex(this.form_replace_text_multiple.text_search), flags)
          this.review_list.push({
            id: product.id,
            images: product.images,
            old_name: product.name,
            new_name: product.name.replace(reg, this.form_replace_text_multiple.text_replace),
            update_status: null,
            update_message: ''
          })
        }
        this.show_dialog.review_product = true
      }
    },

    m__show_replace_text_multiple_dialog() {
      if (!this.list_true.filter(i => i.checked === true).length) {
        this.ntf_w(this.$t('required.select_product'))
        return
      }

      this.action = 'replace'
      this.form_replace_text_multiple = {
        text_search: '',
        text_replace: '',
        regex: '',
        is_regex: false,
        upper_case: false,
        once: false
      }
      this.show_dialog.replace_text_multiple = true
    },

    async m__get_frames() {
      this.frame_list = []
      const response = await this.$http.get('https://cf.atosa.asia/api/frames/get', this.cf())
      this.frame_list = response.body.data
    },

    async m__upload_frame(file) {
      if (file) {
        try {
          const frame = {
            filename: this.remove_unicode(file.name).replace(/[^a-zA-Z0-9]/ig, '_').replace(/\s/ig, '_'),
            base64: await get_base64(file.raw)
          }

          await this.$http.post('https://cf.atosa.asia/api/frames/upload', frame, this.cf())
          await this.m__get_frames()
        } catch (e) {
          console.error(e)
          this.ntf_w(e)
        }
      }
    },

    async m__download_images(url_list) {
      const response = await this.$http.post('https://cf.atosa.asia/api/image/extract_zip', {url_list}, {
        ...this.cf(),
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `extract_images.zip`)
      document.body.appendChild(link)
      link.click()
    },

    async m__get_change_product_images_log(product) {
      this.selected_product = product
      this.loading.change_product_images_log = true
      const response = await this.$http.get('https://cf.atosa.asia/api/image/log/' + product.id, this.cf())
      for (const item of response.body.data) {
        item.is_expanded = true
      }
      this.change_product_images_log = response.body.data
      this.loading.change_product_images_log = false
      this.show_dialog.change_product_images_log = true
    },

    async m__confirm_attach_frame() {
      try {
        await this.$confirm(this.$t('product.add_frame_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.attach_frame = true
      try {
        for (const item of this.attach_result_list) {
          if (this.attach_frame_type === 'main') {
            const new_image = await create_file_from_url('https://cf.atosa.asia/public/images/' + item.new_url_list[0], item.new_url_list[0])
            const response = await this.seller.upload_image(new_image)
            if (response && response.data && response.data.data && response.data.data.resource_id) {
              const resource_id = response.data.data.resource_id

              // todo: replace new images map item to resource id
              const images_map_found = item.images_map.find(i => i.new === item.new_url_list[0])
              if (images_map_found) images_map_found.new = resource_id

              const product_images = this.clone(item.images)
              product_images.shift()

              const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
                shop_id: this.shop.shop_id,
                data: {
                  method: 'POST',
                  uri: 'product/update_item',
                  body: {
                    item_id: item.id,
                    image: {
                      image_id_list: [resource_id, ...product_images]
                    }
                  }
                }
              }, this.cf())
              console.log(item.id, '-', 'update_response main:', update_response.body)

              let result = update_response.body.data
              if (!result.error) {
                const product_metrics = await this.m__get_product_metrics(item)
                const log = {
                  shop_id: this.shop.shop_id,
                  product_id: item.id,
                  old_image_url_list: [this.SHOPEE_IMAGE(item.images[0])],
                  new_image_url_list: [this.SHOPEE_IMAGE(resource_id)],
                  image_type: 'frame',
                  change_type: 'main',
                  api_response: JSON.stringify(update_response.body),
                  allow_replace_first: this.allow_replace_first,
                  product_metrics: product_metrics,
                  images_map: item.images_map,
                  origin_product: JSON.stringify(item)
                }
                this.$http.post('https://cf.atosa.asia/api/image/log', log, this.cf()).catch(console.error)
              }
            }
          }

          if (this.attach_frame_type === 'all' || this.attach_frame_type === 'multiple') {
            const old_image_url_list = []
            const new_image_url_list = []
            const images_map = []
            const image_id_list = []
            for (const new_url of item.new_url_list) {
              if (this.attach_result_selected_list.includes(new_url)) {
                const new_image = await create_file_from_url('https://cf.atosa.asia/public/images/' + new_url, new_url)
                const response = await this.seller.upload_image(new_image)
                if (response && response.data && response.data.data && response.data.data.resource_id) {
                  image_id_list.push(response.data.data.resource_id)

                  // todo: replace new images map item to resource id
                  const images_map_found = item.images_map.find(i => i.new === new_url)
                  if (images_map_found) {
                    images_map_found.new = response.data.data.resource_id
                    old_image_url_list.push(images_map_found.old)
                    new_image_url_list.push(images_map_found.new)
                    images_map.push({
                      old: images_map_found.old,
                      new: images_map_found.new
                    })
                  }
                }
              } else {
                const images_map_found = item.images_map.find(i => i.new === new_url)
                if (images_map_found) {
                  image_id_list.push(images_map_found.old)
                }
              }
            }

            const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
              shop_id: this.shop.shop_id,
              data: {
                method: 'POST',
                uri: 'product/update_item',
                body: {
                  item_id: item.id,
                  image: {
                    image_id_list: image_id_list
                  }
                }
              }
            }, this.cf())
            console.log(item.id, '-', 'update_response all:', update_response.body)

            let result = update_response.body.data
            if (!result.error) {
              const product_metrics = await this.m__get_product_metrics(item)
              const log = {
                shop_id: this.shop.shop_id,
                product_id: item.id,
                old_image_url_list: old_image_url_list.map(i => this.SHOPEE_IMAGE(i)),
                new_image_url_list: new_image_url_list.map(i => this.SHOPEE_IMAGE(i)),
                image_type: 'frame',
                change_type: 'all',
                api_response: JSON.stringify(update_response.body),
                allow_replace_first: this.allow_replace_first,
                product_metrics: product_metrics,
                images_map: images_map,
                origin_product: JSON.stringify(item)
              }
              this.$http.post('https://cf.atosa.asia/api/image/log', log, this.cf()).catch(console.error)
            }
          }
        }

        await this.m__get_products()
        this.ntf_s(this.$t('product.process_adding_frame_complete'))
        this.show_dialog.attach_frame = false
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.attach_frame = false
      }
    },

    async m__select_frame(file) {
      const source = this.add_frame_display === 'all' ? this.list_true.filter(i => i.checked) : [this.selected_product]
      if (!source.length) {
        this.ntf_w(this.$t('required.select_product'))
        return
      }

      this.selected_frame = file

      this.attach_result_list = []
      this.attach_result_selected_list = []
      this.loading.preview_attach_frame = true
      try {
        for (const product of source) {
          const url_list = this.attach_frame_type === 'main'
            ? [product.images[0]]
            : product.images

          const frame_file = await create_file_from_url(file.url)
          const base64 = await get_base64(frame_file)
          const frame = {
            filename: this.remove_unicode(file.filename).replace(/[^a-zA-Z0-9]/ig, '_').replace(/\s/ig, '_'),
            base64: base64
          }

          const result_list = {
            ...product,
            old_url_list: url_list.map(i => this.SHOPEE_IMAGE(i)),
            new_url_list: [],
            images_map: []
          }

          for (const url of url_list) {
            const response = await this.$http.post('https://cf.atosa.asia/api/image/overlay', {
              url_list: [this.SHOPEE_IMAGE(url)],
              frame
            }, this.cf())
            if (response.body.data && response.body.data.output && response.body.data.output.length) {
              result_list.new_url_list.push(response.body.data.output[0])
              result_list.images_map.push({
                old: url,
                new: response.body.data.output[0]
              })

              this.attach_result_selected_list.push(response.body.data.output[0])
            }
          }

          this.attach_result_list.push(result_list)
        }

        if (this.attach_result_list.length) {
          this.url_image_without_frame = this.attach_result_list[0].old_url_list[0]
          this.url_image_with_frame = 'https://cf.atosa.asia/public/images/' + this.attach_result_list[0].new_url_list[0]
          // this.selected_frame = file
        } else {
          this.ntf_w(this.$t('product.error_with_adding_frame'))
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.preview_attach_frame = false
      }
    },

    m__show_attach_frame_dialog(product = null) {

      if (!product && !this.list_true.filter(i => i.checked).length) {
        this.ntf_w(this.$t('required.select_product'))
        return
      }

      this.url_image_without_frame = null
      this.url_image_with_frame = null
      this.selected_frame = null
      this.show_dialog.attach_frame = true
      this.attach_frame_type = 'main'
      this.add_frame_display = 'all'

      if (product) {
        this.selected_product = product
        this.add_frame_display = 'multiple'
      }
    },

    async m__confirm_upload_image() {
      if (!this.preview_image) {
        this.ntf_w(this.$t('required.select_cover_image'))
        return
      }

      try {
        await this.$confirm(this.$t('product.edit_cover_image_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.upload_image = true
      try {
        const response = await this.seller.upload_image(this.preview_image)
        if (response && response.data && response.data.data && response.data.data.resource_id) {
          const resource_id = response.data.data.resource_id
          const product_images = this.clone(this.selected_product.images)
          if (this.allow_replace_first) {
            product_images.shift()
          }

          const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
            shop_id: this.shop.shop_id,
            data: {
              method: 'POST',
              uri: 'product/update_item',
              body: {
                item_id: this.selected_product.id,
                image: {
                  image_id_list: [resource_id, ...product_images]
                }
              }
            }
          }, this.cf())
          console.log('update_response', update_response)

          // todo: write log
          const product_metrics = await this.m__get_product_metrics(this.selected_product)
          const log = {
            shop_id: this.shop.shop_id,
            product_id: this.selected_product.id,
            old_image_url_list: [this.SHOPEE_IMAGE(this.selected_product.images[0])],
            new_image_url_list: [this.SHOPEE_IMAGE(resource_id)],
            image_type: 'main',
            change_type: 'main',
            api_response: JSON.stringify(update_response.body),
            allow_replace_first: this.allow_replace_first,
            product_metrics: product_metrics,
            origin_product: JSON.stringify(this.selected_product)
          }

          // todo: check result
          const result = update_response.body.data
          if (!result.error) {
            this.$http.post('https://cf.atosa.asia/api/image/log', log, this.cf()).catch(console.error)

            await this.m__get_products()
            this.ntf_s(this.$t('product.update_cover_image_success'))
            this.show_dialog.upload_image = false
          } else {
            this.ntf_w(`${this.$t('base.has_an_occurred')}. ${this.$t('base.error_code')}: ${result.message}`)
          }
        } else {
          console.log(response)
          this.ntf_w(this.$t('base.cannot_upload_file'))
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.upload_image = false
      }
    },

    m__on_preview_upload_image(image) {
      this.preview_image = image.raw
      this.preview_image_url = URL.createObjectURL(image.raw)
    },

    m__show_upload_image_dialog(product) {
      this.selected_product = product
      this.show_dialog.upload_image = true
      this.preview_image = null
      this.preview_image_url = null
      this.image_list = []
    },

    async m__get_login() {
      const resp = await this.$http.post('https://api.atosa.asia/api/v1/open-platform/', {
        name: '',
        channel: 'open_platform_shopee',
        redirect_url: `${window.location.origin}/shop`
      }, this.cf())

      if (resp && resp.body && resp.body.data && resp.body.data.url) {
        window.open(resp.body.data.url, '_blank')
      }
    },

    async m__delete_restricted_keyword(data) {
      try {
        await this.$confirm(this.$t('base.delete_file_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        await this.$http.delete(this.API.URL_API_SRV_1 + '/restricted_keywords', {
          params: {
            id: data.id,
            mipeeUserId: this.$store.state.userInfo.username
          },
          ...this.cf()
        })
        await this.m__get_restricted_keyword()
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    async m__delete_product_group(data) {
      try {
        await this.$confirm(this.$t('product.delete_group_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        await this.$http.delete(this.API.URL_API_SRV_1 + '/product_groups', {
          params: {
            id: data.id,
            mipeeUserId: this.$store.state.userInfo.username
          },
          ...this.cf()
        })
        await this.m__get_product_group()
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    m__import_file(e) {
      const input = e.target

      const reader = new FileReader()
      reader.onload = () => {
        const text = reader.result
        for (const line of text.split('\n')) {
          if (!line) continue

          const keyword = line.replace(/\s+/ig, ' ').trim()
          if (!this.form_restricted_keyword.keywords.includes(keyword)) {
            this.form_restricted_keyword.keywords.push(keyword)
          }
        }
      }
      reader.readAsText(input.files[0])

      e.target.value = null
    },

    m__select_file() {
      this.$el.querySelector(`#input_control_detail`).click()
    },

    m__handle_dropdown(command) {
      if (command === 1) {
        this.m__show_add_product_to_group_dialog()
      }
      if (command === 2) {
        this.m__delete_product_from_group()
      }
      if (command === 3) {
        this.m__show_add_product_to_restricted_keyword_dialog()
      }
      if (command === 4) {
        this.m__remove_restricted_keyword_product()
      }
      if (command === 5) {
        this.m__show_add_text_multiple_dialog()
      }
      if (command === 6) {
        this.m__show_remove_text_multiple_dialog()
      }
      if (command === 7) {
        this.m__show_replace_text_multiple_dialog()
      }
    },

    async m__remove_restricted_keyword_product() {
      try {
        await this.$confirm(this.$t('product.delete_product_from_file_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        for (const product of this.list_true.filter(i => i.checked === true)) {
          await this.$http.post(this.API.URL_API_SRV_1 + '/restricted_keywords/remove_product', {}, {
            params: {
              productId: product.id,
              restrictedKeywordId: product.restricted_keyword_id,
              mipeeUserId: this.$store.state.userInfo.username
            },
            ...this.cf()
          })
        }

        await this.m__get_restricted_keyword()
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    async m__add_restricted_keyword_product() {
      if (!this.selected_restricted_keyword_id) {
        return this.ntf_w(this.$t('required.select_file'))
      }

      this.loading.add_restricted_keyword = true

      try {
        for (const product of this.list_true.filter(i => i.checked === true)) {
          await this.$http.post(this.API.URL_API_SRV_1 + '/restricted_keywords/add_product', {}, {
            params: {
              productId: product.id,
              restrictedKeywordId: this.selected_restricted_keyword_id,
              mipeeUserId: this.$store.state.userInfo.username
            },
            ...this.cf()
          })
        }

        await this.m__get_restricted_keyword()
        this.show_dialog.add_product_to_restricted_keyword = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.add_restricted_keyword = false
      }
    },

    m__show_add_product_to_restricted_keyword_dialog() {
      if (!this.shop._id) {
        return
      }

      if (!this.list_true.filter(i => i.checked === true).length) {
        this.ntf_w(this.$t('required.select_product'))
        return
      }

      this.show_dialog.add_product_to_restricted_keyword = true
    },

    async m__update_restricted_keyword() {
      try {
        this.loading.update_restricted_keyword = true

        await this.$http.put(this.API.URL_API_SRV_1 + '/restricted_keywords', {
          shopId: this.shop._id,
          shShopId: this.shop.shop_id,
          mipeeUserId: this.$store.state.userInfo.username,
          ...this.form_restricted_keyword
        }, this.cf())
        await this.m__get_restricted_keyword()
        this.show_dialog.update_keyword = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.update_restricted_keyword = false
      }
    },

    m__remove_keyword(index) {
      this.form_restricted_keyword.keywords.splice(index, 1)
    },

    m__add_keyword() {
      if (!this.restricted_keyword) {
        return
      }

      const keyword = this.restricted_keyword.replace(/\s+/ig, ' ').trim()
      if (!this.form_restricted_keyword.keywords.includes(keyword)) {
        this.form_restricted_keyword.keywords.push(keyword)
      }
      this.restricted_keyword = ''
    },

    m__show_update_keyword_dialog(data) {
      this.form_restricted_keyword = {...data}

      this.show_dialog.update_keyword = true
    },

    async m__get_restricted_keyword() {
      try {
        const response = await this.$http.get(this.API.URL_API_SRV_1 + '/restricted_keywords', {
          params: {
            shopId: this.shop._id,
            shShopId: this.shop.shop_id,
            mipeeUserId: this.$store.state.userInfo.username
          },
          ...this.cf()
        })

        this.restricted_keywords = response.body

        for (const product of this.product_list) {
          const restricted_keyword_found = this.restricted_keywords.find(i => i.productIds.includes(product.id))

          product.restricted_keyword_id = restricted_keyword_found ? restricted_keyword_found.id : null
          product.restricted_keyword_name = restricted_keyword_found ? restricted_keyword_found.name : null
        }
      } catch (e) {
        console.error(e)
      }
    },

    async m__add_restricted_keyword() {
      if (!this.form_restricted_keyword.name) {
        return this.ntf_w(this.$t('required.filename'))
      }

      try {
        this.loading.add_restricted_keyword = true

        await this.$http.post(this.API.URL_API_SRV_1 + '/restricted_keywords', {
          shopId: this.shop._id,
          shShopId: this.shop.shop_id,
          mipeeUserId: this.$store.state.userInfo.username,
          ...this.form_restricted_keyword
        }, this.cf())
        await this.m__get_restricted_keyword()
        this.show_dialog.add_restricted_keyword = false
        this.ntf_s(this.$t('base.add_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.add_restricted_keyword = false
      }
    },

    m__show_add_restricted_keyword_dialog() {
      if (!this.shop._id) {
        return
      }

      this.form_restricted_keyword = {
        id: null,
        name: '',
        keywords: [],
        productIds: []
      }

      this.show_dialog.add_restricted_keyword = true
    },

    async m__delete_product_from_group() {
      if (!this.shop._id) {
        return
      }

      if (!this.list_true.filter(i => i.checked === true).length) {
        this.ntf_w(this.$t('required.select_product'))
        return
      }

      try {
        await this.$confirm(this.$t('product.delete_product_from_group_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        for (const product of this.list_true.filter(i => i.checked === true)) {
          const group_found = this.group_list.find(i => i.productIds.includes(product.id))
          if (group_found) {
            try {
              await this.$http.put(this.API.URL_API_SRV_1 + '/product_groups', {
                id: group_found.id,
                mipeeUserId: this.$store.state.userInfo.username,
                productIds: group_found.productIds.filter(i => i !== product.id)
              })
              product.group_id = null
              product.group_name = null
            } catch (e) {
              console.error(e)
            }
          }
        }
        await this.m__get_product_group()
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    async m__add_product_to_group() {
      if (!this.form_group.groupId) {
        this.ntf_w(this.$t('required.select_group'))
        return
      }

      try {
        for (const product of this.list_true.filter(i => i.checked === true)) {
          const group_found = this.group_list.find(i => i.productIds.includes(product.id))
          if (group_found) {
            try {
              await this.$http.put(this.API.URL_API_SRV_1 + '/product_groups', {
                id: group_found.id,
                mipeeUserId: this.$store.state.userInfo.username,
                productIds: group_found.productIds.filter(i => i !== product.id)
              })
              product.group_id = null
              product.group_name = null
            } catch (e) {
              console.error(e)
            }
          }
        }
        await this.m__get_product_group()

        const group_found = this.group_list.find(i => i.id === this.form_group.groupId)

        this.loading.add_product_to_group = true
        await this.$http.put(this.API.URL_API_SRV_1 + '/product_groups', {
          id: this.form_group.groupId,
          mipeeUserId: this.$store.state.userInfo.username,
          productIds: [...group_found.productIds, ...this.list_true.filter(i => i.checked === true).map(i => i.id)]
        })
        await this.m__get_product_group()
        this.show_dialog.add_product_to_group = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.log(e)
        this.ntf_w(e)
      } finally {
        this.loading.add_product_to_group = false
      }
    },

    m__show_add_product_to_group_dialog() {
      if (!this.shop._id) {
        return
      }

      if (!this.list_true.filter(i => i.checked === true).length) {
        this.ntf_w(this.$t('required.select_product'))
        return
      }

      this.show_dialog.add_product_to_group = true
    },

    async m__add_group() {
      if (!this.form_group.name) {
        this.ntf_w(this.$t('required.group_name'))
        return
      }

      try {
        this.loading.add_group = true
        await this.$http.post(this.API.URL_API_SRV_1 + '/product_groups', {
          shopId: this.shop._id,
          shShopId: this.shop.shop_id,
          mipeeUserId: this.$store.state.userInfo.username,
          ...this.form_group
        })
        await this.m__get_product_group()
        this.show_dialog.add_group = false
        this.ntf_s(this.$t('base.add_success'))
      } catch (e) {
        console.log(e)
        this.ntf_w(e)
      } finally {
        this.loading.add_group = false
      }
    },

    m__show_add_group_dialog() {
      if (!this.shop._id) {
        return
      }

      this.form_group = {
        id: null,
        name: '',
        productIds: []
      }

      this.show_dialog.add_group = true
    },

    async m__get_product_group() {
      try {
        const response = await this.$http.get(this.API.URL_API_SRV_1 + '/product_groups', {
          params: {
            shopId: this.shop._id,
            mipeeUserId: this.$store.state.userInfo.username
          },
          ...this.cf()
        })
        this.group_list = response.body.reverse()

        for (const product of this.product_list) {
          const group_found = this.group_list.find(i => i.productIds.includes(product.id))
          product.group_id = group_found ? group_found.id : null
          product.group_name = group_found ? group_found.name : null
        }
      } catch (e) {
        console.error(e)
      }
    },

    m__check_all() {
      const is_checked_all = this.m__is_checked_all()
      for (const product of this.list_true) {
        product.checked = !is_checked_all
      }
    },

    m__is_checked_all() {
      return this.list_true.length > 0 && this.list_true.filter(i => i.checked === true).length === this.list_true.length
    },

    async m__initial_view() {
      try {
        if (this.shopee_shop.selected.length > 6) {
          let items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)
          if (items.length > 0) {
            const shop = items[0]

            // todo: check role
            if (!this.check_role(shop, 'marketing', 'products')) {
              this.shopee_shop.selected = ''
              return
            }

            this.shop = shop
            this.seller = await this.init_seller(shop)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              this.product_list = []
              return
            }

            const json_data = await this.seller.get_shop_info()
            try {
              let current_info = json_data.data
              if (!current_info.shopid) {
                await this.seller.seller_login()
                await this.m__get_shopee_shop()
                const shop = this.shopee_shop.list.find(i => i._id === this.shopee_shop.selected)
                this.seller.cookie = shop.cookie
                this.shop = shop
              }
            } catch (e) {
              await this.seller.seller_login()
              await this.m__get_shopee_shop()
              const shop = this.shopee_shop.list.find(i => i._id === this.shopee_shop.selected)
              this.seller.cookie = shop.cookie
              this.shop = shop
            }

            await this.m__get_products()
            await this.m__get_product_group()
            await this.m__get_restricted_keyword()

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
        this.loading.get_product = false
      }
    },

    async m__get_products() {
      if (this.shop.extra_data && !this.shop.extra_data.linked) {
        return
      }

      try {
        this.loading.get_product = true

        this.product_list = []
        this.product_clone_list = []

        const cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_all_products', {
          shop_id: this.shop.shop_id
        }, this.cf())

        const product_cache_list = cache_response && cache_response.body && cache_response.body.data && cache_response.body.data.length
          ? typeof cache_response.body.data === 'string' ? JSON.parse(cache_response.body.data) : cache_response.body.data
          : []

        if (product_cache_list.length > 100) {
          const chunk_list = _chunk(product_cache_list, 20)
          for (const chunk of chunk_list) {
            await this.sleep(500)

            const product_ids = chunk.map(i => i.id.toString())
            const product_detail_list = []

            // todo: get cache data
            const products_by_graphql_cache_cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_products_by_graphql', {
              shop_id: this.shop.shop_id,
              product_ids: product_ids
            }, this.cf())
            if (products_by_graphql_cache_cache_response && products_by_graphql_cache_cache_response.body && products_by_graphql_cache_cache_response.body.data) {
              const data = typeof products_by_graphql_cache_cache_response === 'string'
                ? JSON.parse(products_by_graphql_cache_cache_response.body.data)
                : products_by_graphql_cache_cache_response.body.data
              product_detail_list.push(...data.map(i => JSON.parse(i.response)))
            }

            // todo: get missing cache data
            if (product_detail_list.length < chunk.length) {
              const founded_product_ids_set = new Set(product_detail_list.map(i => i.itemid.toString()))
              const missing_product_id = chunk.filter(i => !founded_product_ids_set.has(i.id.toString())).map(i => i.id.toString())
              const products_detail = await this.seller.get_product_by_graphql(missing_product_id)
              if (products_detail && products_detail.data && products_detail.data.products && products_detail.data.products.items) {
                product_detail_list.push(...products_detail.data.products.items)
              }
            }

            for (const item of chunk) {
              const product_detail = product_detail_list.find(i => i.itemid === item.id.toString())
              item.images = product_detail ? product_detail.images : ''

              item.price = item.model_list && item.model_list.length && item.model_list[0].price_info ? +item.model_list[0].price_info.promotion_price : 0
              item.price_before_discount = item.model_list && item.model_list.length && item.model_list[0].price_info ? +item.model_list[0].price_info.normal_price : 0
              item.checked = false
              item.models_stock = this.m__get_reduce_prop(item, 'stock')
              item.models_sold = this.m__get_reduce_prop(item, 'sold')
              item.gmv = item.price_before_discount * item.sold
              item.group_id = null
              item.group_name = null
              item.restricted_keyword_id = null
              item.restricted_keyword_name = null
              item.performance = {
                pv: 0,
                add_to_cart_units: 0,
                confirmed_units: 0,
                confirmed_sales: 0,
                pv_to_add_to_cart_rate: 0,
                add_to_cart_to_confirmed_units_rate: 0
              }
            }
            this.product_list.push(...chunk)
          }

          console.log('loaded products from cache')
        } else {
          let page_index = 1
          let products_resp = await this.seller.get_product_by_page(page_index)
          while (products_resp.length) {
            const product_ids = products_resp.map(i => i.id.toString())
            // console.log('product_ids', product_ids)
            const products_detail = await this.seller.get_product_by_graphql(product_ids)
            if (!products_detail || !products_detail.data) {
              this.ntf_w(this.$t('ads.error_with_getting_products'))
              break;
            }

            for (const item of products_resp) {
              const product_detail = products_detail.data.products.items.find(i => i.itemid === item.id.toString())
              item.images = product_detail ? product_detail.images : ''

              item.price = item.model_list && item.model_list.length && item.model_list[0].price_info ? +item.model_list[0].price_info.promotion_price : 0
              item.price_before_discount = item.model_list && item.model_list.length && item.model_list[0].price_info ? +item.model_list[0].price_info.normal_price : 0
              item.checked = false
              item.models_stock = this.m__get_reduce_prop(item, 'stock')
              item.models_sold = this.m__get_reduce_prop(item, 'sold')
              // item.gmv = item.price_before_discount * item.models_sold
              item.gmv = item.price_before_discount * item.sold
              item.group_id = null
              item.group_name = null
              item.restricted_keyword_id = null
              item.restricted_keyword_name = null
              item.performance = {
                pv: 0,
                add_to_cart_units: 0,
                confirmed_units: 0,
                confirmed_sales: 0,
                pv_to_add_to_cart_rate: 0,
                add_to_cart_to_confirmed_units_rate: 0
              }
            }
            this.product_list.push(...products_resp)
            products_resp = await this.seller.get_product_by_page(page_index + 1)
            page_index++
          }
        }

        let start_time = null, end_time = null
        if (this.period === 'past7days') {
          start_time = this.dayjs().subtract(7, 'd').startOf('d').unix()
          end_time = this.dayjs().startOf('d').unix()
        }
        if (this.period === 'past30days') {
          start_time = this.dayjs().subtract(30, 'd').startOf('d').unix()
          end_time = this.dayjs().startOf('d').unix()
        }

        const product_performance = []
        let page = 1, page_size = 20
        let product_performance_resp = await this.seller.get_product_performance_main(page, page_size, start_time, end_time, this.period)

        while (product_performance_resp && product_performance_resp.data && product_performance_resp.data.result &&
        product_performance_resp.data.result.items && product_performance_resp.data.result.items.length) {
          if (product_performance.length > product_performance_resp.data.result.total) {
            return
          }

          for (const item of product_performance_resp.data.result.items) {
            item.pv_to_add_to_cart_rate = +item.pv ? parseFloat((item.add_to_cart_units / item.pv * 100).toFixed(2)) : 0
            item.add_to_cart_to_confirmed_units_rate = +item.add_to_cart_units ? parseFloat((item.confirmed_units / item.add_to_cart_units * 100).toFixed(2)) : 0
          }

          product_performance.push(...product_performance_resp.data.result.items)
          page++
          product_performance_resp = await this.seller.get_product_performance_main(page, page_size, start_time, end_time, this.period)
        }

        // console.log(product_performance)

        for (const item of product_performance) {
          const product_found = this.product_list.find(i => i.id === item.id)
          if (product_found) product_found.performance = item
        }

        this.product_list = _orderBy(this.product_list, ['performance.confirmed_sales'], ['desc'])

        // todo: test
        // this.product_list = this.product_list.filter(i => i.images.length < 3)
        // console.log(this.product_list.map(i => _pick(i, ['id', 'name'])))

        this.product_clone_list = JSON.parse(JSON.stringify(this.product_list))
        this.loading.get_product = false
        this.m__generate_scrollbar()
      } catch (e) {
        console.error(e)
      }
    },

    m__get_reduce_prop(product, prop) {
      if (product.model_list && product.model_list.length) {
        if (prop === 'stock') {
          return product.model_list.reduce((total, item) => {
            return total + item.stock_detail.total_available_stock || 0
          }, 0)
        } else if (prop === 'gmv') {
          return product.model_list.reduce((total, item) => {
            return total + (item.sold * +item.price_info.promotion_price)
          }, 0)
        } else {
          return product.model_list.reduce((total, item) => {
            return total + item[prop] || 0
          }, 0)
        }
      } else {
        return 0
      }
    },

    m__sort_change({
                     prop,
                     order
                   }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    },

    async m__update_on_review() {
      this.loading.update_on_review = true
      if (this.action === 'add') {
        await this.m__confirm_add_text_multiple()
      }
      if (this.action === 'remove') {
        await this.m__confirm_remove_text_multiple()
      }
      if (this.action === 'replace') {
        await this.m__confirm_replace_text_multiple()
      }
      this.loading.update_on_review = false
    },

    m__show_add_text_multiple_dialog() {
      if (!this.list_true.filter(i => i.checked === true).length) {
        this.ntf_w(this.$t('required.select_product'))
        return
      }

      this.action = 'add'
      this.form_add_text_multiple = {
        text: '',
        position: 'end',
        n_char: 1
      }
      this.show_dialog.add_text_multiple = true
    },

    async m__review_add_text_multiple_dialog() {
      if (this.ignore_review) {
        await this.m__confirm_add_text_multiple()
      } else {
        this.review_list = []

        const checked_product = this.list_true.filter(i => i.checked === true)
        for (const product of checked_product) {
          if (this.form_add_text_multiple.position === 'start') {
            this.review_list.push({
              id: product.id,
              images: product.images,
              old_name: product.name,
              new_name: `${this.form_add_text_multiple.text} ${product.name}`,
              update_status: null,
              update_message: ''
            })
          }
          if (this.form_add_text_multiple.position === 'end') {
            this.review_list.push({
              id: product.id,
              images: product.images,
              old_name: product.name,
              new_name: `${product.name} ${this.form_add_text_multiple.text}`,
              update_status: null,
              update_message: ''
            })
          }
          if (this.form_add_text_multiple.position === 'after_n_char') {
            this.review_list.push({
              id: product.id,
              images: product.images,
              old_name: product.name,
              new_name: this.m__add_text_after_n_characters(product.name, this.form_add_text_multiple.text, +this.form_add_text_multiple.n_char),
              update_status: null,
              update_message: ''
            })
          }
        }
        this.show_dialog.review_product = true
      }
    },

    async m__confirm_add_text_multiple() {
      this.loading.add_text_multiple = true

      try {
        await this.$confirm(this.$t('base.change_product_name_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })

        const checked_product = this.list_true.filter(i => i.checked === true)
        for (const product of checked_product) {
          const old_name = product.name

          if (this.form_add_text_multiple.position === 'start') {
            product.name = `${this.form_add_text_multiple.text} ${product.name}`.trim()
          }
          if (this.form_add_text_multiple.position === 'end') {
            product.name = `${product.name} ${this.form_add_text_multiple.text}`.trim()
          }
          if (this.form_add_text_multiple.position === 'after_n_char') {
            product.name = this.m__add_text_after_n_characters(product.name, this.form_add_text_multiple.text, +this.form_add_text_multiple.n_char)
          }

          const data = _pick(product, ['id', 'name'])
          if (product.name.length > 120) {
            const review_found = this.review_list.find(i => i.id === product.id)
            if (review_found) {
              review_found.update_status = false
              review_found.update_message = this.$t('product.name_too_long')
              continue
            }
          }

          const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
            shop_id: this.shop.shop_id,
            data: {
              method: 'POST',
              uri: 'product/update_item',
              body: {
                item_id: data.id,
                item_name: data.name
              }
            }
          }, this.cf())

          const review_found = this.review_list.find(i => i.id === product.id)
          if (review_found && update_response && update_response.body) {
            review_found.update_status = update_response.body.data.error === ''
            review_found.update_message = update_response.body.data.error === '' ? this.$t('base.update_success') : update_response.body.data.message

            // todo: save log
            this.m__get_product_metrics(product)
              .then(product_metrics => {
                const log = {
                  shop_id: this.shop.shop_id,
                  product_id: data.id,
                  old_name: old_name,
                  new_name: product.name,
                  change_type: 'add_text',
                  api_response: JSON.stringify(update_response.body),
                  product_metrics: product_metrics,
                  origin_product: JSON.stringify(product)
                }
                this.$http.post('https://cf.atosa.asia/api/name/log', log, this.cf()).catch(console.error)
              })
          }
        }
        this.show_dialog.add_text_multiple = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.log(e)
      } finally {
        this.loading.add_text_multiple = false
      }
    },

    m__show_remove_text_multiple_dialog() {
      if (!this.list_true.filter(i => i.checked === true).length) {
        this.ntf_w(this.$t('required.select_product'))
        return
      }

      this.action = 'remove'
      this.form_remove_text_multiple = {
        text: '',
        regex: '',
        is_regex: false,
        upper_case: false,
        once: false
      }
      this.show_dialog.remove_text_multiple = true
    },

    m__escape_regex(string) {
      return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
    },

    async m__review_remove_text_multiple_dialog() {
      if (this.ignore_review) {
        await this.m__confirm_remove_text_multiple()
      } else {
        this.review_list = []

        const checked_product = this.list_true.filter(i => i.checked === true)
        for (const product of checked_product) {
          let flags = ''
          if (!this.form_remove_text_multiple.upper_case) flags += 'i'
          if (!this.form_remove_text_multiple.once) flags += 'g'
          const reg = new RegExp(this.m__escape_regex(this.form_remove_text_multiple.text), flags)
          this.review_list.push({
            id: product.id,
            images: product.images,
            old_name: product.name,
            new_name: product.name.replace(reg, ''),
            update_status: null,
            update_message: ''
          })
        }
        this.show_dialog.review_product = true
      }
    },

    async m__confirm_remove_text_multiple() {
      if (!this.form_remove_text_multiple.text) {
        this.ntf_w(this.$t('required.remove_text'))
        return
      }

      this.loading.remove_text_multiple = true

      try {
        await this.$confirm(this.$t('base.change_product_name_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })

        const checked_product = this.list_true.filter(i => i.checked === true)
        for (const product of checked_product) {
          const old_name = product.name

          let flags = ''
          if (!this.form_remove_text_multiple.upper_case) flags += 'i'
          if (!this.form_remove_text_multiple.once) flags += 'g'
          const reg = new RegExp(this.m__escape_regex(this.form_remove_text_multiple.text), flags)
          product.name = product.name.replace(reg, '').trim()

          const data = _pick(product, ['id', 'name'])

          const update_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/request_to_shopee', {
            shop_id: this.shop.shop_id,
            data: {
              method: 'POST',
              uri: 'product/update_item',
              body: {
                item_id: data.id,
                item_name: data.name
              }
            }
          }, this.cf())

          const review_found = this.review_list.find(i => i.id === product.id)
          if (review_found && update_response && update_response.body) {
            review_found.update_status = update_response.body.data.error === ''
            review_found.update_message = update_response.body.data.error === '' ? this.$t('base.update_success') : update_response.body.data.message

            // todo: save log
            this.m__get_product_metrics(product)
              .then(product_metrics => {
                const log = {
                  shop_id: this.shop.shop_id,
                  product_id: data.id,
                  old_name: old_name,
                  new_name: product.name,
                  change_type: 'remove_text',
                  api_response: JSON.stringify(update_response.body),
                  product_metrics: product_metrics,
                  origin_product: JSON.stringify(product)
                }
                this.$http.post('https://cf.atosa.asia/api/name/log', log, this.cf()).catch(console.error)
              })
          }
        }

        this.show_dialog.review_product = false
        this.show_dialog.remove_text_multiple = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.log(e)
      } finally {
        this.loading.remove_text_multiple = false
      }
    }
  }
}
</script>

<style lang="scss">
.upload-demo {
  .el-upload__input {
    display: none !important;
  }

  .el-upload-list__item {
    margin-right: 40px !important;
    margin-bottom: 20px !important;
    cursor: pointer;
  }
}

.image-item:hover {
  .image-overlay {
    opacity: 1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/index.vue